import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AddDeployment = {
  accountId: Scalars['String']['input'];
  awsRegion: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ApiV1StackInput = {
  deploymentId: Scalars['String']['input'];
  excludeStageFromPath: Scalars['Boolean']['input'];
};

export type ApiV2StackInput = {
  deploymentId: Scalars['String']['input'];
};

export type CreateGitConnectionInput = {
  deploymentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  providerType: Scalars['String']['input'];
};

export type CreateHostedZoneWithCertResult = {
  __typename?: 'CreateHostedZoneWithCertResult';
  certDnsChangeInfoId?: Maybe<Scalars['String']['output']>;
  hostedZoneChangeInfoId?: Maybe<Scalars['String']['output']>;
};

export type DeployAnyCfnStack = {
  deploymentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type DeployCdnStack = {
  altCertificateArn?: InputMaybe<Scalars['String']['input']>;
  altFullDomainName?: InputMaybe<Scalars['String']['input']>;
  buildFolderPath?: InputMaybe<Scalars['String']['input']>;
  buildScriptPath?: InputMaybe<Scalars['String']['input']>;
  buildspecPath?: InputMaybe<Scalars['String']['input']>;
  buildtimeJson: Scalars['String']['input'];
  callbackUri?: InputMaybe<Scalars['String']['input']>;
  deploymentId: Scalars['String']['input'];
  emailPasswordEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  gitBranch: Scalars['String']['input'];
  gitConnectionArn: Scalars['String']['input'];
  gitRepositoryId: Scalars['String']['input'];
  googleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  localhostUrl?: InputMaybe<Scalars['String']['input']>;
  logoutUri?: InputMaybe<Scalars['String']['input']>;
  oidcClientId?: InputMaybe<Scalars['String']['input']>;
  oidcClientSecret?: InputMaybe<Scalars['String']['input']>;
  oidcEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  oidcProviderName?: InputMaybe<Scalars['String']['input']>;
  oidcThumbprint?: InputMaybe<Scalars['String']['input']>;
  oidcUrl?: InputMaybe<Scalars['String']['input']>;
  wafEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webHostname?: InputMaybe<Scalars['String']['input']>;
};

export type DeployCfnStack = {
  awsLambdaRuntime?: InputMaybe<Scalars['String']['input']>;
  buildFolderPath?: InputMaybe<Scalars['String']['input']>;
  buildScriptPath?: InputMaybe<Scalars['String']['input']>;
  buildspecPath: Scalars['String']['input'];
  buildtimeJson: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
  gitBranch: Scalars['String']['input'];
  gitConnectionArn: Scalars['String']['input'];
  gitRepositoryId: Scalars['String']['input'];
  handler?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lambdaExecutionRoleArnOverride?: InputMaybe<Scalars['String']['input']>;
};

export type DeployDbStack = {
  alarmsEnabled: Scalars['Boolean']['input'];
  allocatedStorage: Scalars['Int']['input'];
  backupRetentionPeriod: Scalars['Int']['input'];
  createReplica: Scalars['Boolean']['input'];
  dbType: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
  engineVersion: Scalars['String']['input'];
  family: Scalars['String']['input'];
  id: Scalars['String']['input'];
  instanceClass: Scalars['String']['input'];
  logRetentionDays: Scalars['Int']['input'];
  multiAz: Scalars['Boolean']['input'];
  snapshotId: Scalars['String']['input'];
};

export type DeployEcsFargateStack = {
  alarmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyRequired: Scalars['Boolean']['input'];
  apiResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  apiV2ResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoscaleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  buildspecPath?: InputMaybe<Scalars['String']['input']>;
  buildtimeJson: Scalars['String']['input'];
  cicdManualApproval?: InputMaybe<Scalars['Boolean']['input']>;
  deploymentId: Scalars['String']['input'];
  dockerfilePath?: InputMaybe<Scalars['String']['input']>;
  ecsTaskCpu: Scalars['Int']['input'];
  ecsTaskRam: Scalars['Int']['input'];
  gitBranch: Scalars['String']['input'];
  gitConnectionArn: Scalars['String']['input'];
  gitRepositoryId: Scalars['String']['input'];
  healthCheckPath?: InputMaybe<Scalars['String']['input']>;
  healthCheckPort?: InputMaybe<Scalars['Int']['input']>;
  iamAuthRequired: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  instanceCount: Scalars['Int']['input'];
  logRetentionDays?: InputMaybe<Scalars['Int']['input']>;
  mapToRootPath?: InputMaybe<Scalars['Boolean']['input']>;
  maxInstanceCount?: InputMaybe<Scalars['Int']['input']>;
  runtimeJson: Scalars['String']['input'];
  servicePort: Scalars['Int']['input'];
  stickySessionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  stickySessionType?: InputMaybe<Scalars['String']['input']>;
};

export type DeployEcsWsFargateStack = {
  alarmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoscaleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  buildspecPath?: InputMaybe<Scalars['String']['input']>;
  buildtimeJson: Scalars['String']['input'];
  cicdManualApproval?: InputMaybe<Scalars['Boolean']['input']>;
  deploymentId: Scalars['String']['input'];
  dockerfilePath?: InputMaybe<Scalars['String']['input']>;
  ecsTaskCpu: Scalars['Int']['input'];
  ecsTaskRam: Scalars['Int']['input'];
  fullDomainName?: InputMaybe<Scalars['String']['input']>;
  gitBranch: Scalars['String']['input'];
  gitConnectionArn: Scalars['String']['input'];
  gitRepositoryId: Scalars['String']['input'];
  healthCheckPath?: InputMaybe<Scalars['String']['input']>;
  healthCheckPort?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  instanceCount: Scalars['Int']['input'];
  logRetentionDays?: InputMaybe<Scalars['Int']['input']>;
  maxInstanceCount?: InputMaybe<Scalars['Int']['input']>;
  runtimeJson: Scalars['String']['input'];
  servicePort: Scalars['Int']['input'];
  sslCertificateArn?: InputMaybe<Scalars['String']['input']>;
  stickySessionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  stickySessionType?: InputMaybe<Scalars['String']['input']>;
  wafEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Deployment = {
  __typename?: 'Deployment';
  accountId?: Maybe<Scalars['String']['output']>;
  awsRegion?: Maybe<Scalars['String']['output']>;
  defaultAlarmsEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultDatabaseRetention?: Maybe<Scalars['Int']['output']>;
  defaultLogRetentionDays?: Maybe<Scalars['Int']['output']>;
  defaultRequireCicdManualApproval?: Maybe<Scalars['Boolean']['output']>;
  fullDomainName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  waffleDomain?: Maybe<Scalars['String']['output']>;
};

export type DomainNameCertificate = {
  __typename?: 'DomainNameCertificate';
  arn?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type EditDeployment = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type EditOrganization = {
  apiV1Enabled: Scalars['Boolean']['input'];
  customDomainEnabled: Scalars['Boolean']['input'];
  databaseEnabled: Scalars['Boolean']['input'];
  envFeaturesStackEnabled: Scalars['Boolean']['input'];
  httpApiEnabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onboardingComplete: Scalars['Boolean']['input'];
  singleDeployment: Scalars['Boolean']['input'];
  workInProgressFeaturesEnabled: Scalars['Boolean']['input'];
  wsApiEnabled: Scalars['Boolean']['input'];
};

export type EditServiceStack = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type EnvFeaturesStackInput = {
  availabilityZone1?: InputMaybe<Scalars['String']['input']>;
  availabilityZone2?: InputMaybe<Scalars['String']['input']>;
  cognitoAlertsEnabled: Scalars['Boolean']['input'];
  cognitoAllowAdminCreateUserOnly: Scalars['Boolean']['input'];
  cognitoEnabled: Scalars['Boolean']['input'];
  cognitoMfaRequired: Scalars['Boolean']['input'];
  defaultAlarmsEnabled: Scalars['Boolean']['input'];
  defaultDatabaseRetention: Scalars['Int']['input'];
  defaultRequireManualCicdApproval: Scalars['Boolean']['input'];
  deploymentDomainName: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
  emailNotificationList: Scalars['String']['input'];
  fromEmailName?: InputMaybe<Scalars['String']['input']>;
  googleClientId: Scalars['String']['input'];
  googleClientSecret: Scalars['String']['input'];
  httpApiV2Enabled: Scalars['Boolean']['input'];
  httpApiV2Subdomain: Scalars['String']['input'];
  logRetentionDays: Scalars['Int']['input'];
  primaryPrivateCidr: Scalars['String']['input'];
  primaryPublicCidr: Scalars['String']['input'];
  restApiV1Enabled: Scalars['Boolean']['input'];
  restApiV1Subdomain: Scalars['String']['input'];
  secondaryPrivateCidr: Scalars['String']['input'];
  secondaryPublicCidr: Scalars['String']['input'];
  vpcCidr: Scalars['String']['input'];
  vpcEnabled: Scalars['Boolean']['input'];
};

export type Features = {
  __typename?: 'Features';
  apiV1Enabled?: Maybe<Scalars['Boolean']['output']>;
  customDomainEnabled?: Maybe<Scalars['Boolean']['output']>;
  databaseEnabled?: Maybe<Scalars['Boolean']['output']>;
  envFeaturesStackEnabled?: Maybe<Scalars['Boolean']['output']>;
  httpApiEnabled?: Maybe<Scalars['Boolean']['output']>;
  singleDeployment?: Maybe<Scalars['Boolean']['output']>;
  workInProgressFeaturesEnabled?: Maybe<Scalars['Boolean']['output']>;
  wsApiEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GitConnection = {
  __typename?: 'GitConnection';
  connectionStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerAccountId?: Maybe<Scalars['String']['output']>;
  pendingConnectionLink?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
};

export type HostedZone = {
  __typename?: 'HostedZone';
  domainName: Scalars['String']['output'];
  hostedZoneId: Scalars['String']['output'];
  nameServers?: Maybe<Array<Scalars['String']['output']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addMyServiceStack?: Maybe<ServiceStack>;
  addOrganization?: Maybe<Organization>;
  assignMyDeploymentAccountAndRegion?: Maybe<Deployment>;
  createMyDeployment?: Maybe<Deployment>;
  createMyGitConnection?: Maybe<GitConnection>;
  createMyHostedZoneWithCert?: Maybe<CreateHostedZoneWithCertResult>;
  deployMyAnyCfnStack?: Maybe<Scalars['String']['output']>;
  deployMyApiGatewayStage?: Maybe<Scalars['String']['output']>;
  deployMyCdnStack?: Maybe<Scalars['String']['output']>;
  deployMyCfnStack?: Maybe<Scalars['String']['output']>;
  deployMyDbStack?: Maybe<Scalars['String']['output']>;
  deployMyEcsFargateStack?: Maybe<Scalars['String']['output']>;
  deployMyEcsWsFargateStack?: Maybe<Scalars['String']['output']>;
  deployMyEnvFeaturesStack?: Maybe<StackStatus>;
  editMyDeployment?: Maybe<Deployment>;
  editMyServiceStack?: Maybe<ServiceStack>;
  editOrganization?: Maybe<Organization>;
  inviteMyTeamMember?: Maybe<User>;
  removeMyCdnStack?: Maybe<Scalars['String']['output']>;
  removeMyCfnStack?: Maybe<Scalars['String']['output']>;
  removeMyDbStack?: Maybe<Scalars['String']['output']>;
  removeMyEcsFargateStack?: Maybe<Scalars['String']['output']>;
  removeMyEcsWsFargateStack?: Maybe<Scalars['String']['output']>;
  setMyOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  setMyOrganization?: Maybe<Organization>;
  tempTestMyWaffleRole?: Maybe<TestResult>;
};


export type MutationAddMyServiceStackArgs = {
  stackId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationAddOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationAssignMyDeploymentAccountAndRegionArgs = {
  accountId: Scalars['String']['input'];
  awsRegion: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
};


export type MutationCreateMyDeploymentArgs = {
  deploymentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMyGitConnectionArgs = {
  gitConnectionInput: CreateGitConnectionInput;
};


export type MutationCreateMyHostedZoneWithCertArgs = {
  deploymentId: Scalars['String']['input'];
  fullDomainName: Scalars['String']['input'];
};


export type MutationDeployMyAnyCfnStackArgs = {
  stackDeploymentInput: DeployAnyCfnStack;
};


export type MutationDeployMyApiGatewayStageArgs = {
  deploymentId: Scalars['String']['input'];
};


export type MutationDeployMyCdnStackArgs = {
  stackDeploymentInput: DeployCdnStack;
};


export type MutationDeployMyCfnStackArgs = {
  stackDeploymentInput: DeployCfnStack;
};


export type MutationDeployMyDbStackArgs = {
  stackDeploymentInput: DeployDbStack;
};


export type MutationDeployMyEcsFargateStackArgs = {
  stackDeploymentInput: DeployEcsFargateStack;
};


export type MutationDeployMyEcsWsFargateStackArgs = {
  stackDeploymentInput: DeployEcsWsFargateStack;
};


export type MutationDeployMyEnvFeaturesStackArgs = {
  envFeaturesStackInput: EnvFeaturesStackInput;
};


export type MutationEditMyDeploymentArgs = {
  deploymentInput: EditDeployment;
};


export type MutationEditMyServiceStackArgs = {
  stackInput: EditServiceStack;
};


export type MutationEditOrganizationArgs = {
  organizationInput: EditOrganization;
};


export type MutationInviteMyTeamMemberArgs = {
  email: Scalars['String']['input'];
};


export type MutationRemoveMyCdnStackArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMyCfnStackArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMyDbStackArgs = {
  databaseId: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMyEcsFargateStackArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMyEcsWsFargateStackArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetMyOnboardingCompleteArgs = {
  complete: Scalars['Boolean']['input'];
};


export type MutationSetMyOrganizationArgs = {
  organizationName: Scalars['String']['input'];
};


export type MutationTempTestMyWaffleRoleArgs = {
  accountId: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  features?: Maybe<Features>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onboardingComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  findMyDbStackId?: Maybe<Scalars['String']['output']>;
  getAllOrganizations?: Maybe<Array<Organization>>;
  getMyAlertsStackStatus?: Maybe<StackStatus>;
  getMyAuthenticationStackStatus?: Maybe<StackStatus>;
  getMyCdnServiceStackPublicUrl?: Maybe<Scalars['String']['output']>;
  getMyCdnServiceStackStatus?: Maybe<StackStatus>;
  getMyCertificateCnameRecordStatus?: Maybe<Scalars['String']['output']>;
  getMyCfnServiceStackStatus?: Maybe<StackStatus>;
  getMyCfnStackIds: Array<Scalars['String']['output']>;
  getMyCfnStackLatestEvents?: Maybe<Scalars['String']['output']>;
  getMyCfnStackParameters?: Maybe<Scalars['String']['output']>;
  getMyCfnStackStatus?: Maybe<StackStatusDetails>;
  getMyCfnStackTemplate?: Maybe<Scalars['String']['output']>;
  getMyDbEngineVersions?: Maybe<Array<Scalars['String']['output']>>;
  getMyDbFamilies?: Maybe<Array<Scalars['String']['output']>>;
  getMyDbInstanceClasses?: Maybe<Array<Scalars['String']['output']>>;
  getMyDbServiceStackStatus?: Maybe<StackStatus>;
  getMyDbSnapshotIds?: Maybe<Array<Scalars['String']['output']>>;
  getMyDeployments?: Maybe<Array<Deployment>>;
  getMyDeploymentsStackStatus?: Maybe<StackStatus>;
  getMyDomainNameCertificate?: Maybe<DomainNameCertificate>;
  getMyEcsServiceStackPublicUrl?: Maybe<Scalars['String']['output']>;
  getMyEcsServiceStackStatus?: Maybe<StackStatus>;
  getMyEcsWsServiceStackPublicUrl?: Maybe<Scalars['String']['output']>;
  getMyEcsWsServiceStackStatus?: Maybe<StackStatus>;
  getMyEnvFeaturesStackStatus?: Maybe<StackStatus>;
  getMyGitConnections?: Maybe<Array<GitConnection>>;
  getMyHostedZoneChangeStatus?: Maybe<Scalars['String']['output']>;
  getMyHostedZones?: Maybe<Array<HostedZone>>;
  getMyHttpApiUrl?: Maybe<Scalars['String']['output']>;
  getMyHttpApiV2StackStatus?: Maybe<StackStatus>;
  getMyOrganization?: Maybe<Organization>;
  getMyRestApiUrl?: Maybe<Scalars['String']['output']>;
  getMyRestApiV1StackStatus?: Maybe<StackStatus>;
  getMyServiceStacks?: Maybe<Array<ServiceStack>>;
  getMyTeamMembers?: Maybe<Array<User>>;
  getMyVpcStackStatus?: Maybe<StackStatus>;
  getMyWaffleCfnTemplate?: Maybe<Scalars['String']['output']>;
  getOrganization?: Maybe<Organization>;
  getWcaUserById?: Maybe<User>;
  helloWorld?: Maybe<Scalars['String']['output']>;
  testMyWaffleRole?: Maybe<TestResult>;
  whoAmI?: Maybe<User>;
};


export type QueryFindMyDbStackIdArgs = {
  databaseId: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyAlertsStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyAuthenticationStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyCdnServiceStackPublicUrlArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
};


export type QueryGetMyCdnServiceStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyCertificateCnameRecordStatusArgs = {
  changeInfoId: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyCfnServiceStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyCfnStackIdsArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyCfnStackLatestEventsArgs = {
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
};


export type QueryGetMyCfnStackParametersArgs = {
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
};


export type QueryGetMyCfnStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
};


export type QueryGetMyCfnStackTemplateArgs = {
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
};


export type QueryGetMyDbEngineVersionsArgs = {
  dbType: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
  family: Scalars['String']['input'];
};


export type QueryGetMyDbFamiliesArgs = {
  dbType: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyDbInstanceClassesArgs = {
  dbType: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
  engineVersion: Scalars['String']['input'];
};


export type QueryGetMyDbServiceStackStatusArgs = {
  databaseId: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyDbSnapshotIdsArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyDeploymentsStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyDomainNameCertificateArgs = {
  deploymentId: Scalars['String']['input'];
  domainName: Scalars['String']['input'];
};


export type QueryGetMyEcsServiceStackPublicUrlArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
};


export type QueryGetMyEcsServiceStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyEcsWsServiceStackPublicUrlArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
};


export type QueryGetMyEcsWsServiceStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyEnvFeaturesStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyGitConnectionsArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyHostedZoneChangeStatusArgs = {
  changeInfoId: Scalars['String']['input'];
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyHostedZonesArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyHttpApiUrlArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyHttpApiV2StackStatusArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyRestApiUrlArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyRestApiV1StackStatusArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetMyVpcStackStatusArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetWcaUserByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryTestMyWaffleRoleArgs = {
  deploymentId: Scalars['String']['input'];
};

export type ServiceStack = {
  __typename?: 'ServiceStack';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StackStatus = {
  __typename?: 'StackStatus';
  id: Scalars['String']['output'];
  parametersJSON?: Maybe<Scalars['String']['output']>;
  stackId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type StackStatusDetails = {
  __typename?: 'StackStatusDetails';
  fullDetails?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parametersJSON?: Maybe<Scalars['String']['output']>;
  stackId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TestResult = {
  __typename?: 'TestResult';
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AssignMyDeploymentAccountAndRegionMutationVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  awsRegion: Scalars['String']['input'];
}>;


export type AssignMyDeploymentAccountAndRegionMutation = { __typename?: 'Mutation', assignMyDeploymentAccountAndRegion?: { __typename?: 'Deployment', id: string, name?: string | null, accountId?: string | null, awsRegion?: string | null, version?: string | null, defaultLogRetentionDays?: number | null, defaultAlarmsEnabled?: boolean | null, defaultDatabaseRetention?: number | null, defaultRequireCicdManualApproval?: boolean | null, fullDomainName?: string | null, waffleDomain?: string | null } | null };

export type CreateMyDeploymentMutationVariables = Exact<{
  deploymentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMyDeploymentMutation = { __typename?: 'Mutation', createMyDeployment?: { __typename?: 'Deployment', id: string, name?: string | null, accountId?: string | null, awsRegion?: string | null, version?: string | null, defaultLogRetentionDays?: number | null, defaultAlarmsEnabled?: boolean | null, defaultDatabaseRetention?: number | null, defaultRequireCicdManualApproval?: boolean | null, fullDomainName?: string | null, waffleDomain?: string | null } | null };

export type CreateMyGitConnectionMutationVariables = Exact<{
  gitConnectionInput: CreateGitConnectionInput;
}>;


export type CreateMyGitConnectionMutation = { __typename?: 'Mutation', createMyGitConnection?: { __typename?: 'GitConnection', id?: string | null, name?: string | null, connectionStatus?: string | null, ownerAccountId?: string | null, providerType?: string | null, pendingConnectionLink?: string | null } | null };

export type CreateMyHostedZoneWithCertMutationVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  fullDomainName: Scalars['String']['input'];
}>;


export type CreateMyHostedZoneWithCertMutation = { __typename?: 'Mutation', createMyHostedZoneWithCert?: { __typename?: 'CreateHostedZoneWithCertResult', hostedZoneChangeInfoId?: string | null, certDnsChangeInfoId?: string | null } | null };

export type DeployMyApiGatewayStageMutationVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type DeployMyApiGatewayStageMutation = { __typename?: 'Mutation', deployMyApiGatewayStage?: string | null };

export type DeployMyEnvFeaturesStackMutationVariables = Exact<{
  envFeaturesStackInput: EnvFeaturesStackInput;
}>;


export type DeployMyEnvFeaturesStackMutation = { __typename?: 'Mutation', deployMyEnvFeaturesStack?: { __typename?: 'StackStatus', id: string, stackId?: string | null, parametersJSON?: string | null } | null };

export type EditMyDeploymentMutationVariables = Exact<{
  deploymentInput: EditDeployment;
}>;


export type EditMyDeploymentMutation = { __typename?: 'Mutation', editMyDeployment?: { __typename?: 'Deployment', id: string, name?: string | null, accountId?: string | null, awsRegion?: string | null, defaultLogRetentionDays?: number | null, defaultAlarmsEnabled?: boolean | null, defaultDatabaseRetention?: number | null, defaultRequireCicdManualApproval?: boolean | null, fullDomainName?: string | null } | null };

export type GetMyCertificateCnameRecordStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  changeInfoId: Scalars['String']['input'];
}>;


export type GetMyCertificateCnameRecordStatusQuery = { __typename?: 'Query', getMyCertificateCnameRecordStatus?: string | null };

export type GetMyDeploymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyDeploymentsQuery = { __typename?: 'Query', getMyDeployments?: Array<{ __typename?: 'Deployment', id: string, name?: string | null, accountId?: string | null, awsRegion?: string | null, version?: string | null, defaultLogRetentionDays?: number | null, defaultAlarmsEnabled?: boolean | null, defaultDatabaseRetention?: number | null, defaultRequireCicdManualApproval?: boolean | null, fullDomainName?: string | null, waffleDomain?: string | null }> | null };

export type GetMyDomainNameCertificateQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  domainName: Scalars['String']['input'];
}>;


export type GetMyDomainNameCertificateQuery = { __typename?: 'Query', getMyDomainNameCertificate?: { __typename?: 'DomainNameCertificate', id: string, arn?: string | null, status?: string | null } | null };

export type GetMyEnvFeaturesStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyEnvFeaturesStackStatusQuery = { __typename?: 'Query', getMyEnvFeaturesStackStatus?: { __typename?: 'StackStatus', id: string, stackId?: string | null, status?: string | null, parametersJSON?: string | null } | null };

export type GetMyGitConnectionsQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyGitConnectionsQuery = { __typename?: 'Query', getMyGitConnections?: Array<{ __typename?: 'GitConnection', id?: string | null, name?: string | null, connectionStatus?: string | null, ownerAccountId?: string | null, providerType?: string | null, pendingConnectionLink?: string | null }> | null };

export type GetMyHostedZoneChangeStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  changeInfoId: Scalars['String']['input'];
}>;


export type GetMyHostedZoneChangeStatusQuery = { __typename?: 'Query', getMyHostedZoneChangeStatus?: string | null };

export type GetMyHostedZonesQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyHostedZonesQuery = { __typename?: 'Query', getMyHostedZones?: Array<{ __typename?: 'HostedZone', hostedZoneId: string, nameServers?: Array<string> | null, domainName: string }> | null };

export type GetMyHttpApiUrlQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyHttpApiUrlQuery = { __typename?: 'Query', getMyHttpApiUrl?: string | null };

export type GetMyRestApiUrlQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyRestApiUrlQuery = { __typename?: 'Query', getMyRestApiUrl?: string | null };

export type GetMyWaffleCfnTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyWaffleCfnTemplateQuery = { __typename?: 'Query', getMyWaffleCfnTemplate?: string | null };

export type GetMyAlertsStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyAlertsStackStatusQuery = { __typename?: 'Query', getMyAlertsStackStatus?: { __typename?: 'StackStatus', id: string, stackId?: string | null, status?: string | null, parametersJSON?: string | null } | null };

export type GetMyAuthenticationStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyAuthenticationStackStatusQuery = { __typename?: 'Query', getMyAuthenticationStackStatus?: { __typename?: 'StackStatus', id: string, stackId?: string | null, status?: string | null, parametersJSON?: string | null } | null };

export type GetMyDeploymentsStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyDeploymentsStackStatusQuery = { __typename?: 'Query', getMyDeploymentsStackStatus?: { __typename?: 'StackStatus', id: string, stackId?: string | null, status?: string | null, parametersJSON?: string | null } | null };

export type GetMyHttpApiV2StackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyHttpApiV2StackStatusQuery = { __typename?: 'Query', getMyHttpApiV2StackStatus?: { __typename?: 'StackStatus', id: string, stackId?: string | null, status?: string | null, parametersJSON?: string | null } | null };

export type GetMyRestApiV1StackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyRestApiV1StackStatusQuery = { __typename?: 'Query', getMyRestApiV1StackStatus?: { __typename?: 'StackStatus', id: string, stackId?: string | null, status?: string | null, parametersJSON?: string | null } | null };

export type GetMyVpcStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyVpcStackStatusQuery = { __typename?: 'Query', getMyVpcStackStatus?: { __typename?: 'StackStatus', id: string, stackId?: string | null, status?: string | null, parametersJSON?: string | null } | null };

export type TempTestMyWaffleRoleMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type TempTestMyWaffleRoleMutation = { __typename?: 'Mutation', tempTestMyWaffleRole?: { __typename?: 'TestResult', id: string, passed: boolean, details?: string | null } | null };

export type TestMyWaffleRoleQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type TestMyWaffleRoleQuery = { __typename?: 'Query', testMyWaffleRole?: { __typename?: 'TestResult', id: string, passed: boolean, details?: string | null } | null };

export type HelloWorldQueryVariables = Exact<{ [key: string]: never; }>;


export type HelloWorldQuery = { __typename?: 'Query', helloWorld?: string | null };

export type AddOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type AddOrganizationMutation = { __typename?: 'Mutation', addOrganization?: { __typename?: 'Organization', id: string, name: string } | null };

export type EditOrganizationMutationVariables = Exact<{
  organizationInput: EditOrganization;
}>;


export type EditOrganizationMutation = { __typename?: 'Mutation', editOrganization?: { __typename?: 'Organization', id: string, name: string, onboardingComplete?: boolean | null, features?: { __typename?: 'Features', workInProgressFeaturesEnabled?: boolean | null, envFeaturesStackEnabled?: boolean | null, singleDeployment?: boolean | null, databaseEnabled?: boolean | null, apiV1Enabled?: boolean | null, wsApiEnabled?: boolean | null, httpApiEnabled?: boolean | null, customDomainEnabled?: boolean | null } | null } | null };

export type GetAllOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganizationsQuery = { __typename?: 'Query', getAllOrganizations?: Array<{ __typename?: 'Organization', id: string, name: string }> | null };

export type GetMyOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationQuery = { __typename?: 'Query', getMyOrganization?: { __typename?: 'Organization', name: string, id: string, onboardingComplete?: boolean | null, features?: { __typename?: 'Features', workInProgressFeaturesEnabled?: boolean | null, envFeaturesStackEnabled?: boolean | null, singleDeployment?: boolean | null, databaseEnabled?: boolean | null, apiV1Enabled?: boolean | null, wsApiEnabled?: boolean | null, httpApiEnabled?: boolean | null, customDomainEnabled?: boolean | null } | null } | null };

export type GetOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', getOrganization?: { __typename?: 'Organization', id: string, name: string, onboardingComplete?: boolean | null, features?: { __typename?: 'Features', workInProgressFeaturesEnabled?: boolean | null, envFeaturesStackEnabled?: boolean | null, singleDeployment?: boolean | null, databaseEnabled?: boolean | null, apiV1Enabled?: boolean | null, wsApiEnabled?: boolean | null, httpApiEnabled?: boolean | null, customDomainEnabled?: boolean | null } | null } | null };

export type SetMyOnboardingCompleteMutationVariables = Exact<{
  complete: Scalars['Boolean']['input'];
}>;


export type SetMyOnboardingCompleteMutation = { __typename?: 'Mutation', setMyOnboardingComplete?: boolean | null };

export type AddMyServiceStackMutationVariables = Exact<{
  stackId: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type AddMyServiceStackMutation = { __typename?: 'Mutation', addMyServiceStack?: { __typename?: 'ServiceStack', id: string, name?: string | null, type: string } | null };

export type DeployMyAnyCfnStackMutationVariables = Exact<{
  stackDeploymentInput: DeployAnyCfnStack;
}>;


export type DeployMyAnyCfnStackMutation = { __typename?: 'Mutation', deployMyAnyCfnStack?: string | null };

export type DeployMyCdnStackMutationVariables = Exact<{
  stackDeploymentInput: DeployCdnStack;
}>;


export type DeployMyCdnStackMutation = { __typename?: 'Mutation', deployMyCdnStack?: string | null };

export type DeployMyCfnStackMutationVariables = Exact<{
  stackDeploymentInput: DeployCfnStack;
}>;


export type DeployMyCfnStackMutation = { __typename?: 'Mutation', deployMyCfnStack?: string | null };

export type DeployMyDbStackMutationVariables = Exact<{
  stackDeploymentInput: DeployDbStack;
}>;


export type DeployMyDbStackMutation = { __typename?: 'Mutation', deployMyDbStack?: string | null };

export type DeployMyEcsFargateStackMutationVariables = Exact<{
  stackDeploymentInput: DeployEcsFargateStack;
}>;


export type DeployMyEcsFargateStackMutation = { __typename?: 'Mutation', deployMyEcsFargateStack?: string | null };

export type DeployMyEcsWsFargateStackMutationVariables = Exact<{
  stackDeploymentInput: DeployEcsWsFargateStack;
}>;


export type DeployMyEcsWsFargateStackMutation = { __typename?: 'Mutation', deployMyEcsWsFargateStack?: string | null };

export type EditMyServiceStackMutationVariables = Exact<{
  stackInput: EditServiceStack;
}>;


export type EditMyServiceStackMutation = { __typename?: 'Mutation', editMyServiceStack?: { __typename?: 'ServiceStack', id: string, name?: string | null, type: string } | null };

export type GetMyCdnServiceStackPublicUrlQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type GetMyCdnServiceStackPublicUrlQuery = { __typename?: 'Query', getMyCdnServiceStackPublicUrl?: string | null };

export type GetMyCdnServiceStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyCdnServiceStackStatusQuery = { __typename?: 'Query', getMyCdnServiceStackStatus?: { __typename?: 'StackStatus', id: string, status?: string | null, parametersJSON?: string | null, stackId?: string | null } | null };

export type GetMyCfnServiceStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyCfnServiceStackStatusQuery = { __typename?: 'Query', getMyCfnServiceStackStatus?: { __typename?: 'StackStatus', id: string, status?: string | null, parametersJSON?: string | null, stackId?: string | null } | null };

export type GetMyCfnStackIdsQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyCfnStackIdsQuery = { __typename?: 'Query', getMyCfnStackIds: Array<string> };

export type GetMyCfnStackLatestEventsQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
}>;


export type GetMyCfnStackLatestEventsQuery = { __typename?: 'Query', getMyCfnStackLatestEvents?: string | null };

export type GetMyCfnStackParametersQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
}>;


export type GetMyCfnStackParametersQuery = { __typename?: 'Query', getMyCfnStackParameters?: string | null };

export type GetMyCfnStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
}>;


export type GetMyCfnStackStatusQuery = { __typename?: 'Query', getMyCfnStackStatus?: { __typename?: 'StackStatusDetails', id: string, status?: string | null, parametersJSON?: string | null, stackId?: string | null, fullDetails?: string | null } | null };

export type GetMyCfnStackTemplateQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
}>;


export type GetMyCfnStackTemplateQuery = { __typename?: 'Query', getMyCfnStackTemplate?: string | null };

export type GetMyDbEngineVersionsQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  dbType: Scalars['String']['input'];
  family: Scalars['String']['input'];
}>;


export type GetMyDbEngineVersionsQuery = { __typename?: 'Query', getMyDbEngineVersions?: Array<string> | null };

export type GetMyDbFamiliesQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  dbType: Scalars['String']['input'];
}>;


export type GetMyDbFamiliesQuery = { __typename?: 'Query', getMyDbFamilies?: Array<string> | null };

export type GetMyDbInstanceClassesQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  dbType: Scalars['String']['input'];
  engineVersion: Scalars['String']['input'];
}>;


export type GetMyDbInstanceClassesQuery = { __typename?: 'Query', getMyDbInstanceClasses?: Array<string> | null };

export type GetMyDbServiceStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyDbServiceStackStatusQuery = { __typename?: 'Query', getMyDbServiceStackStatus?: { __typename?: 'StackStatus', id: string, status?: string | null, parametersJSON?: string | null, stackId?: string | null } | null };

export type GetMyDbSnapshotIdsQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetMyDbSnapshotIdsQuery = { __typename?: 'Query', getMyDbSnapshotIds?: Array<string> | null };

export type GetMyEcsServiceStackPublicUrlQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type GetMyEcsServiceStackPublicUrlQuery = { __typename?: 'Query', getMyEcsServiceStackPublicUrl?: string | null };

export type GetMyEcsServiceStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyEcsServiceStackStatusQuery = { __typename?: 'Query', getMyEcsServiceStackStatus?: { __typename?: 'StackStatus', id: string, status?: string | null, parametersJSON?: string | null, stackId?: string | null } | null };

export type GetMyEcsWsServiceStackPublicUrlQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type GetMyEcsWsServiceStackPublicUrlQuery = { __typename?: 'Query', getMyEcsWsServiceStackPublicUrl?: string | null };

export type GetMyEcsWsServiceStackStatusQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  stackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyEcsWsServiceStackStatusQuery = { __typename?: 'Query', getMyEcsWsServiceStackStatus?: { __typename?: 'StackStatus', id: string, status?: string | null, parametersJSON?: string | null, stackId?: string | null } | null };

export type GetMyServiceStacksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyServiceStacksQuery = { __typename?: 'Query', getMyServiceStacks?: Array<{ __typename?: 'ServiceStack', id: string, name?: string | null, type: string }> | null };

export type RemoveMyCdnStackMutationVariables = Exact<{
  stackId?: InputMaybe<Scalars['String']['input']>;
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type RemoveMyCdnStackMutation = { __typename?: 'Mutation', removeMyCdnStack?: string | null };

export type RemoveMyCfnStackMutationVariables = Exact<{
  stackId?: InputMaybe<Scalars['String']['input']>;
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type RemoveMyCfnStackMutation = { __typename?: 'Mutation', removeMyCfnStack?: string | null };

export type RemoveMyDbStackMutationVariables = Exact<{
  stackId?: InputMaybe<Scalars['String']['input']>;
  deploymentId: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
}>;


export type RemoveMyDbStackMutation = { __typename?: 'Mutation', removeMyDbStack?: string | null };

export type RemoveMyEcsFargateStackMutationVariables = Exact<{
  stackId?: InputMaybe<Scalars['String']['input']>;
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type RemoveMyEcsFargateStackMutation = { __typename?: 'Mutation', removeMyEcsFargateStack?: string | null };

export type RemoveMyEcsWsFargateStackMutationVariables = Exact<{
  stackId?: InputMaybe<Scalars['String']['input']>;
  deploymentId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type RemoveMyEcsWsFargateStackMutation = { __typename?: 'Mutation', removeMyEcsWsFargateStack?: string | null };

export type GetMyTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTeamMembersQuery = { __typename?: 'Query', getMyTeamMembers?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, status?: string | null }> | null };

export type InviteMyTeamMemberMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type InviteMyTeamMemberMutation = { __typename?: 'Mutation', inviteMyTeamMember?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, status?: string | null } | null };

export type SetMyOrganizationMutationVariables = Exact<{
  organizationName: Scalars['String']['input'];
}>;


export type SetMyOrganizationMutation = { __typename?: 'Mutation', setMyOrganization?: { __typename?: 'Organization', id: string, name: string, onboardingComplete?: boolean | null, features?: { __typename?: 'Features', singleDeployment?: boolean | null } | null } | null };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename?: 'Query', whoAmI?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, picture?: string | null, role?: string | null, organizationId?: string | null } | null };


export const AssignMyDeploymentAccountAndRegionDocument = gql`
    mutation AssignMyDeploymentAccountAndRegion($deploymentId: String!, $accountId: String!, $awsRegion: String!) {
  assignMyDeploymentAccountAndRegion(
    deploymentId: $deploymentId
    accountId: $accountId
    awsRegion: $awsRegion
  ) {
    id
    name
    accountId
    awsRegion
    version
    defaultLogRetentionDays
    defaultAlarmsEnabled
    defaultDatabaseRetention
    defaultRequireCicdManualApproval
    fullDomainName
    waffleDomain
  }
}
    `;
export type AssignMyDeploymentAccountAndRegionMutationFn = Apollo.MutationFunction<AssignMyDeploymentAccountAndRegionMutation, AssignMyDeploymentAccountAndRegionMutationVariables>;

/**
 * __useAssignMyDeploymentAccountAndRegionMutation__
 *
 * To run a mutation, you first call `useAssignMyDeploymentAccountAndRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMyDeploymentAccountAndRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMyDeploymentAccountAndRegionMutation, { data, loading, error }] = useAssignMyDeploymentAccountAndRegionMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      accountId: // value for 'accountId'
 *      awsRegion: // value for 'awsRegion'
 *   },
 * });
 */
export function useAssignMyDeploymentAccountAndRegionMutation(baseOptions?: Apollo.MutationHookOptions<AssignMyDeploymentAccountAndRegionMutation, AssignMyDeploymentAccountAndRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMyDeploymentAccountAndRegionMutation, AssignMyDeploymentAccountAndRegionMutationVariables>(AssignMyDeploymentAccountAndRegionDocument, options);
      }
export type AssignMyDeploymentAccountAndRegionMutationHookResult = ReturnType<typeof useAssignMyDeploymentAccountAndRegionMutation>;
export type AssignMyDeploymentAccountAndRegionMutationResult = Apollo.MutationResult<AssignMyDeploymentAccountAndRegionMutation>;
export type AssignMyDeploymentAccountAndRegionMutationOptions = Apollo.BaseMutationOptions<AssignMyDeploymentAccountAndRegionMutation, AssignMyDeploymentAccountAndRegionMutationVariables>;
export const CreateMyDeploymentDocument = gql`
    mutation CreateMyDeployment($deploymentId: String) {
  createMyDeployment(deploymentId: $deploymentId) {
    id
    name
    accountId
    awsRegion
    version
    defaultLogRetentionDays
    defaultAlarmsEnabled
    defaultDatabaseRetention
    defaultRequireCicdManualApproval
    fullDomainName
    waffleDomain
  }
}
    `;
export type CreateMyDeploymentMutationFn = Apollo.MutationFunction<CreateMyDeploymentMutation, CreateMyDeploymentMutationVariables>;

/**
 * __useCreateMyDeploymentMutation__
 *
 * To run a mutation, you first call `useCreateMyDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyDeploymentMutation, { data, loading, error }] = useCreateMyDeploymentMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useCreateMyDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyDeploymentMutation, CreateMyDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyDeploymentMutation, CreateMyDeploymentMutationVariables>(CreateMyDeploymentDocument, options);
      }
export type CreateMyDeploymentMutationHookResult = ReturnType<typeof useCreateMyDeploymentMutation>;
export type CreateMyDeploymentMutationResult = Apollo.MutationResult<CreateMyDeploymentMutation>;
export type CreateMyDeploymentMutationOptions = Apollo.BaseMutationOptions<CreateMyDeploymentMutation, CreateMyDeploymentMutationVariables>;
export const CreateMyGitConnectionDocument = gql`
    mutation CreateMyGitConnection($gitConnectionInput: CreateGitConnectionInput!) {
  createMyGitConnection(gitConnectionInput: $gitConnectionInput) {
    id
    name
    connectionStatus
    ownerAccountId
    providerType
    pendingConnectionLink
  }
}
    `;
export type CreateMyGitConnectionMutationFn = Apollo.MutationFunction<CreateMyGitConnectionMutation, CreateMyGitConnectionMutationVariables>;

/**
 * __useCreateMyGitConnectionMutation__
 *
 * To run a mutation, you first call `useCreateMyGitConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyGitConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyGitConnectionMutation, { data, loading, error }] = useCreateMyGitConnectionMutation({
 *   variables: {
 *      gitConnectionInput: // value for 'gitConnectionInput'
 *   },
 * });
 */
export function useCreateMyGitConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyGitConnectionMutation, CreateMyGitConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyGitConnectionMutation, CreateMyGitConnectionMutationVariables>(CreateMyGitConnectionDocument, options);
      }
export type CreateMyGitConnectionMutationHookResult = ReturnType<typeof useCreateMyGitConnectionMutation>;
export type CreateMyGitConnectionMutationResult = Apollo.MutationResult<CreateMyGitConnectionMutation>;
export type CreateMyGitConnectionMutationOptions = Apollo.BaseMutationOptions<CreateMyGitConnectionMutation, CreateMyGitConnectionMutationVariables>;
export const CreateMyHostedZoneWithCertDocument = gql`
    mutation CreateMyHostedZoneWithCert($deploymentId: String!, $fullDomainName: String!) {
  createMyHostedZoneWithCert(
    deploymentId: $deploymentId
    fullDomainName: $fullDomainName
  ) {
    hostedZoneChangeInfoId
    certDnsChangeInfoId
  }
}
    `;
export type CreateMyHostedZoneWithCertMutationFn = Apollo.MutationFunction<CreateMyHostedZoneWithCertMutation, CreateMyHostedZoneWithCertMutationVariables>;

/**
 * __useCreateMyHostedZoneWithCertMutation__
 *
 * To run a mutation, you first call `useCreateMyHostedZoneWithCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyHostedZoneWithCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyHostedZoneWithCertMutation, { data, loading, error }] = useCreateMyHostedZoneWithCertMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      fullDomainName: // value for 'fullDomainName'
 *   },
 * });
 */
export function useCreateMyHostedZoneWithCertMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyHostedZoneWithCertMutation, CreateMyHostedZoneWithCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyHostedZoneWithCertMutation, CreateMyHostedZoneWithCertMutationVariables>(CreateMyHostedZoneWithCertDocument, options);
      }
export type CreateMyHostedZoneWithCertMutationHookResult = ReturnType<typeof useCreateMyHostedZoneWithCertMutation>;
export type CreateMyHostedZoneWithCertMutationResult = Apollo.MutationResult<CreateMyHostedZoneWithCertMutation>;
export type CreateMyHostedZoneWithCertMutationOptions = Apollo.BaseMutationOptions<CreateMyHostedZoneWithCertMutation, CreateMyHostedZoneWithCertMutationVariables>;
export const DeployMyApiGatewayStageDocument = gql`
    mutation DeployMyApiGatewayStage($deploymentId: String!) {
  deployMyApiGatewayStage(deploymentId: $deploymentId)
}
    `;
export type DeployMyApiGatewayStageMutationFn = Apollo.MutationFunction<DeployMyApiGatewayStageMutation, DeployMyApiGatewayStageMutationVariables>;

/**
 * __useDeployMyApiGatewayStageMutation__
 *
 * To run a mutation, you first call `useDeployMyApiGatewayStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyApiGatewayStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyApiGatewayStageMutation, { data, loading, error }] = useDeployMyApiGatewayStageMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useDeployMyApiGatewayStageMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyApiGatewayStageMutation, DeployMyApiGatewayStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyApiGatewayStageMutation, DeployMyApiGatewayStageMutationVariables>(DeployMyApiGatewayStageDocument, options);
      }
export type DeployMyApiGatewayStageMutationHookResult = ReturnType<typeof useDeployMyApiGatewayStageMutation>;
export type DeployMyApiGatewayStageMutationResult = Apollo.MutationResult<DeployMyApiGatewayStageMutation>;
export type DeployMyApiGatewayStageMutationOptions = Apollo.BaseMutationOptions<DeployMyApiGatewayStageMutation, DeployMyApiGatewayStageMutationVariables>;
export const DeployMyEnvFeaturesStackDocument = gql`
    mutation DeployMyEnvFeaturesStack($envFeaturesStackInput: EnvFeaturesStackInput!) {
  deployMyEnvFeaturesStack(envFeaturesStackInput: $envFeaturesStackInput) {
    id
    stackId
    parametersJSON
  }
}
    `;
export type DeployMyEnvFeaturesStackMutationFn = Apollo.MutationFunction<DeployMyEnvFeaturesStackMutation, DeployMyEnvFeaturesStackMutationVariables>;

/**
 * __useDeployMyEnvFeaturesStackMutation__
 *
 * To run a mutation, you first call `useDeployMyEnvFeaturesStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyEnvFeaturesStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyEnvFeaturesStackMutation, { data, loading, error }] = useDeployMyEnvFeaturesStackMutation({
 *   variables: {
 *      envFeaturesStackInput: // value for 'envFeaturesStackInput'
 *   },
 * });
 */
export function useDeployMyEnvFeaturesStackMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyEnvFeaturesStackMutation, DeployMyEnvFeaturesStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyEnvFeaturesStackMutation, DeployMyEnvFeaturesStackMutationVariables>(DeployMyEnvFeaturesStackDocument, options);
      }
export type DeployMyEnvFeaturesStackMutationHookResult = ReturnType<typeof useDeployMyEnvFeaturesStackMutation>;
export type DeployMyEnvFeaturesStackMutationResult = Apollo.MutationResult<DeployMyEnvFeaturesStackMutation>;
export type DeployMyEnvFeaturesStackMutationOptions = Apollo.BaseMutationOptions<DeployMyEnvFeaturesStackMutation, DeployMyEnvFeaturesStackMutationVariables>;
export const EditMyDeploymentDocument = gql`
    mutation EditMyDeployment($deploymentInput: EditDeployment!) {
  editMyDeployment(deploymentInput: $deploymentInput) {
    id
    name
    accountId
    awsRegion
    defaultLogRetentionDays
    defaultAlarmsEnabled
    defaultDatabaseRetention
    defaultRequireCicdManualApproval
    fullDomainName
  }
}
    `;
export type EditMyDeploymentMutationFn = Apollo.MutationFunction<EditMyDeploymentMutation, EditMyDeploymentMutationVariables>;

/**
 * __useEditMyDeploymentMutation__
 *
 * To run a mutation, you first call `useEditMyDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMyDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMyDeploymentMutation, { data, loading, error }] = useEditMyDeploymentMutation({
 *   variables: {
 *      deploymentInput: // value for 'deploymentInput'
 *   },
 * });
 */
export function useEditMyDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<EditMyDeploymentMutation, EditMyDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMyDeploymentMutation, EditMyDeploymentMutationVariables>(EditMyDeploymentDocument, options);
      }
export type EditMyDeploymentMutationHookResult = ReturnType<typeof useEditMyDeploymentMutation>;
export type EditMyDeploymentMutationResult = Apollo.MutationResult<EditMyDeploymentMutation>;
export type EditMyDeploymentMutationOptions = Apollo.BaseMutationOptions<EditMyDeploymentMutation, EditMyDeploymentMutationVariables>;
export const GetMyCertificateCnameRecordStatusDocument = gql`
    query GetMyCertificateCnameRecordStatus($deploymentId: String!, $changeInfoId: String!) {
  getMyCertificateCnameRecordStatus(
    deploymentId: $deploymentId
    changeInfoId: $changeInfoId
  )
}
    `;

/**
 * __useGetMyCertificateCnameRecordStatusQuery__
 *
 * To run a query within a React component, call `useGetMyCertificateCnameRecordStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCertificateCnameRecordStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCertificateCnameRecordStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      changeInfoId: // value for 'changeInfoId'
 *   },
 * });
 */
export function useGetMyCertificateCnameRecordStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyCertificateCnameRecordStatusQuery, GetMyCertificateCnameRecordStatusQueryVariables> & ({ variables: GetMyCertificateCnameRecordStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCertificateCnameRecordStatusQuery, GetMyCertificateCnameRecordStatusQueryVariables>(GetMyCertificateCnameRecordStatusDocument, options);
      }
export function useGetMyCertificateCnameRecordStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCertificateCnameRecordStatusQuery, GetMyCertificateCnameRecordStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCertificateCnameRecordStatusQuery, GetMyCertificateCnameRecordStatusQueryVariables>(GetMyCertificateCnameRecordStatusDocument, options);
        }
export function useGetMyCertificateCnameRecordStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCertificateCnameRecordStatusQuery, GetMyCertificateCnameRecordStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCertificateCnameRecordStatusQuery, GetMyCertificateCnameRecordStatusQueryVariables>(GetMyCertificateCnameRecordStatusDocument, options);
        }
export type GetMyCertificateCnameRecordStatusQueryHookResult = ReturnType<typeof useGetMyCertificateCnameRecordStatusQuery>;
export type GetMyCertificateCnameRecordStatusLazyQueryHookResult = ReturnType<typeof useGetMyCertificateCnameRecordStatusLazyQuery>;
export type GetMyCertificateCnameRecordStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyCertificateCnameRecordStatusSuspenseQuery>;
export type GetMyCertificateCnameRecordStatusQueryResult = Apollo.QueryResult<GetMyCertificateCnameRecordStatusQuery, GetMyCertificateCnameRecordStatusQueryVariables>;
export const GetMyDeploymentsDocument = gql`
    query GetMyDeployments {
  getMyDeployments {
    id
    name
    accountId
    awsRegion
    version
    defaultLogRetentionDays
    defaultAlarmsEnabled
    defaultDatabaseRetention
    defaultRequireCicdManualApproval
    fullDomainName
    waffleDomain
  }
}
    `;

/**
 * __useGetMyDeploymentsQuery__
 *
 * To run a query within a React component, call `useGetMyDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDeploymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDeploymentsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyDeploymentsQuery, GetMyDeploymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDeploymentsQuery, GetMyDeploymentsQueryVariables>(GetMyDeploymentsDocument, options);
      }
export function useGetMyDeploymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDeploymentsQuery, GetMyDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDeploymentsQuery, GetMyDeploymentsQueryVariables>(GetMyDeploymentsDocument, options);
        }
export function useGetMyDeploymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDeploymentsQuery, GetMyDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDeploymentsQuery, GetMyDeploymentsQueryVariables>(GetMyDeploymentsDocument, options);
        }
export type GetMyDeploymentsQueryHookResult = ReturnType<typeof useGetMyDeploymentsQuery>;
export type GetMyDeploymentsLazyQueryHookResult = ReturnType<typeof useGetMyDeploymentsLazyQuery>;
export type GetMyDeploymentsSuspenseQueryHookResult = ReturnType<typeof useGetMyDeploymentsSuspenseQuery>;
export type GetMyDeploymentsQueryResult = Apollo.QueryResult<GetMyDeploymentsQuery, GetMyDeploymentsQueryVariables>;
export const GetMyDomainNameCertificateDocument = gql`
    query GetMyDomainNameCertificate($deploymentId: String!, $domainName: String!) {
  getMyDomainNameCertificate(deploymentId: $deploymentId, domainName: $domainName) {
    id
    arn
    status
  }
}
    `;

/**
 * __useGetMyDomainNameCertificateQuery__
 *
 * To run a query within a React component, call `useGetMyDomainNameCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDomainNameCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDomainNameCertificateQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      domainName: // value for 'domainName'
 *   },
 * });
 */
export function useGetMyDomainNameCertificateQuery(baseOptions: Apollo.QueryHookOptions<GetMyDomainNameCertificateQuery, GetMyDomainNameCertificateQueryVariables> & ({ variables: GetMyDomainNameCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDomainNameCertificateQuery, GetMyDomainNameCertificateQueryVariables>(GetMyDomainNameCertificateDocument, options);
      }
export function useGetMyDomainNameCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDomainNameCertificateQuery, GetMyDomainNameCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDomainNameCertificateQuery, GetMyDomainNameCertificateQueryVariables>(GetMyDomainNameCertificateDocument, options);
        }
export function useGetMyDomainNameCertificateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDomainNameCertificateQuery, GetMyDomainNameCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDomainNameCertificateQuery, GetMyDomainNameCertificateQueryVariables>(GetMyDomainNameCertificateDocument, options);
        }
export type GetMyDomainNameCertificateQueryHookResult = ReturnType<typeof useGetMyDomainNameCertificateQuery>;
export type GetMyDomainNameCertificateLazyQueryHookResult = ReturnType<typeof useGetMyDomainNameCertificateLazyQuery>;
export type GetMyDomainNameCertificateSuspenseQueryHookResult = ReturnType<typeof useGetMyDomainNameCertificateSuspenseQuery>;
export type GetMyDomainNameCertificateQueryResult = Apollo.QueryResult<GetMyDomainNameCertificateQuery, GetMyDomainNameCertificateQueryVariables>;
export const GetMyEnvFeaturesStackStatusDocument = gql`
    query getMyEnvFeaturesStackStatus($deploymentId: String!, $stackId: String) {
  getMyEnvFeaturesStackStatus(deploymentId: $deploymentId, stackId: $stackId) {
    id
    stackId
    status
    parametersJSON
  }
}
    `;

/**
 * __useGetMyEnvFeaturesStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyEnvFeaturesStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEnvFeaturesStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEnvFeaturesStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyEnvFeaturesStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyEnvFeaturesStackStatusQuery, GetMyEnvFeaturesStackStatusQueryVariables> & ({ variables: GetMyEnvFeaturesStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEnvFeaturesStackStatusQuery, GetMyEnvFeaturesStackStatusQueryVariables>(GetMyEnvFeaturesStackStatusDocument, options);
      }
export function useGetMyEnvFeaturesStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEnvFeaturesStackStatusQuery, GetMyEnvFeaturesStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEnvFeaturesStackStatusQuery, GetMyEnvFeaturesStackStatusQueryVariables>(GetMyEnvFeaturesStackStatusDocument, options);
        }
export function useGetMyEnvFeaturesStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEnvFeaturesStackStatusQuery, GetMyEnvFeaturesStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEnvFeaturesStackStatusQuery, GetMyEnvFeaturesStackStatusQueryVariables>(GetMyEnvFeaturesStackStatusDocument, options);
        }
export type GetMyEnvFeaturesStackStatusQueryHookResult = ReturnType<typeof useGetMyEnvFeaturesStackStatusQuery>;
export type GetMyEnvFeaturesStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyEnvFeaturesStackStatusLazyQuery>;
export type GetMyEnvFeaturesStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyEnvFeaturesStackStatusSuspenseQuery>;
export type GetMyEnvFeaturesStackStatusQueryResult = Apollo.QueryResult<GetMyEnvFeaturesStackStatusQuery, GetMyEnvFeaturesStackStatusQueryVariables>;
export const GetMyGitConnectionsDocument = gql`
    query GetMyGitConnections($deploymentId: String!) {
  getMyGitConnections(deploymentId: $deploymentId) {
    id
    name
    connectionStatus
    ownerAccountId
    providerType
    pendingConnectionLink
  }
}
    `;

/**
 * __useGetMyGitConnectionsQuery__
 *
 * To run a query within a React component, call `useGetMyGitConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGitConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGitConnectionsQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyGitConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetMyGitConnectionsQuery, GetMyGitConnectionsQueryVariables> & ({ variables: GetMyGitConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGitConnectionsQuery, GetMyGitConnectionsQueryVariables>(GetMyGitConnectionsDocument, options);
      }
export function useGetMyGitConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGitConnectionsQuery, GetMyGitConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGitConnectionsQuery, GetMyGitConnectionsQueryVariables>(GetMyGitConnectionsDocument, options);
        }
export function useGetMyGitConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyGitConnectionsQuery, GetMyGitConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyGitConnectionsQuery, GetMyGitConnectionsQueryVariables>(GetMyGitConnectionsDocument, options);
        }
export type GetMyGitConnectionsQueryHookResult = ReturnType<typeof useGetMyGitConnectionsQuery>;
export type GetMyGitConnectionsLazyQueryHookResult = ReturnType<typeof useGetMyGitConnectionsLazyQuery>;
export type GetMyGitConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetMyGitConnectionsSuspenseQuery>;
export type GetMyGitConnectionsQueryResult = Apollo.QueryResult<GetMyGitConnectionsQuery, GetMyGitConnectionsQueryVariables>;
export const GetMyHostedZoneChangeStatusDocument = gql`
    query getMyHostedZoneChangeStatus($deploymentId: String!, $changeInfoId: String!) {
  getMyHostedZoneChangeStatus(
    deploymentId: $deploymentId
    changeInfoId: $changeInfoId
  )
}
    `;

/**
 * __useGetMyHostedZoneChangeStatusQuery__
 *
 * To run a query within a React component, call `useGetMyHostedZoneChangeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyHostedZoneChangeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyHostedZoneChangeStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      changeInfoId: // value for 'changeInfoId'
 *   },
 * });
 */
export function useGetMyHostedZoneChangeStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyHostedZoneChangeStatusQuery, GetMyHostedZoneChangeStatusQueryVariables> & ({ variables: GetMyHostedZoneChangeStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyHostedZoneChangeStatusQuery, GetMyHostedZoneChangeStatusQueryVariables>(GetMyHostedZoneChangeStatusDocument, options);
      }
export function useGetMyHostedZoneChangeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyHostedZoneChangeStatusQuery, GetMyHostedZoneChangeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyHostedZoneChangeStatusQuery, GetMyHostedZoneChangeStatusQueryVariables>(GetMyHostedZoneChangeStatusDocument, options);
        }
export function useGetMyHostedZoneChangeStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyHostedZoneChangeStatusQuery, GetMyHostedZoneChangeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyHostedZoneChangeStatusQuery, GetMyHostedZoneChangeStatusQueryVariables>(GetMyHostedZoneChangeStatusDocument, options);
        }
export type GetMyHostedZoneChangeStatusQueryHookResult = ReturnType<typeof useGetMyHostedZoneChangeStatusQuery>;
export type GetMyHostedZoneChangeStatusLazyQueryHookResult = ReturnType<typeof useGetMyHostedZoneChangeStatusLazyQuery>;
export type GetMyHostedZoneChangeStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyHostedZoneChangeStatusSuspenseQuery>;
export type GetMyHostedZoneChangeStatusQueryResult = Apollo.QueryResult<GetMyHostedZoneChangeStatusQuery, GetMyHostedZoneChangeStatusQueryVariables>;
export const GetMyHostedZonesDocument = gql`
    query getMyHostedZones($deploymentId: String!) {
  getMyHostedZones(deploymentId: $deploymentId) {
    hostedZoneId
    nameServers
    domainName
  }
}
    `;

/**
 * __useGetMyHostedZonesQuery__
 *
 * To run a query within a React component, call `useGetMyHostedZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyHostedZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyHostedZonesQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyHostedZonesQuery(baseOptions: Apollo.QueryHookOptions<GetMyHostedZonesQuery, GetMyHostedZonesQueryVariables> & ({ variables: GetMyHostedZonesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyHostedZonesQuery, GetMyHostedZonesQueryVariables>(GetMyHostedZonesDocument, options);
      }
export function useGetMyHostedZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyHostedZonesQuery, GetMyHostedZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyHostedZonesQuery, GetMyHostedZonesQueryVariables>(GetMyHostedZonesDocument, options);
        }
export function useGetMyHostedZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyHostedZonesQuery, GetMyHostedZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyHostedZonesQuery, GetMyHostedZonesQueryVariables>(GetMyHostedZonesDocument, options);
        }
export type GetMyHostedZonesQueryHookResult = ReturnType<typeof useGetMyHostedZonesQuery>;
export type GetMyHostedZonesLazyQueryHookResult = ReturnType<typeof useGetMyHostedZonesLazyQuery>;
export type GetMyHostedZonesSuspenseQueryHookResult = ReturnType<typeof useGetMyHostedZonesSuspenseQuery>;
export type GetMyHostedZonesQueryResult = Apollo.QueryResult<GetMyHostedZonesQuery, GetMyHostedZonesQueryVariables>;
export const GetMyHttpApiUrlDocument = gql`
    query getMyHttpApiUrl($deploymentId: String!) {
  getMyHttpApiUrl(deploymentId: $deploymentId)
}
    `;

/**
 * __useGetMyHttpApiUrlQuery__
 *
 * To run a query within a React component, call `useGetMyHttpApiUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyHttpApiUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyHttpApiUrlQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyHttpApiUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyHttpApiUrlQuery, GetMyHttpApiUrlQueryVariables> & ({ variables: GetMyHttpApiUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyHttpApiUrlQuery, GetMyHttpApiUrlQueryVariables>(GetMyHttpApiUrlDocument, options);
      }
export function useGetMyHttpApiUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyHttpApiUrlQuery, GetMyHttpApiUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyHttpApiUrlQuery, GetMyHttpApiUrlQueryVariables>(GetMyHttpApiUrlDocument, options);
        }
export function useGetMyHttpApiUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyHttpApiUrlQuery, GetMyHttpApiUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyHttpApiUrlQuery, GetMyHttpApiUrlQueryVariables>(GetMyHttpApiUrlDocument, options);
        }
export type GetMyHttpApiUrlQueryHookResult = ReturnType<typeof useGetMyHttpApiUrlQuery>;
export type GetMyHttpApiUrlLazyQueryHookResult = ReturnType<typeof useGetMyHttpApiUrlLazyQuery>;
export type GetMyHttpApiUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyHttpApiUrlSuspenseQuery>;
export type GetMyHttpApiUrlQueryResult = Apollo.QueryResult<GetMyHttpApiUrlQuery, GetMyHttpApiUrlQueryVariables>;
export const GetMyRestApiUrlDocument = gql`
    query getMyRestApiUrl($deploymentId: String!) {
  getMyRestApiUrl(deploymentId: $deploymentId)
}
    `;

/**
 * __useGetMyRestApiUrlQuery__
 *
 * To run a query within a React component, call `useGetMyRestApiUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRestApiUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRestApiUrlQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyRestApiUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyRestApiUrlQuery, GetMyRestApiUrlQueryVariables> & ({ variables: GetMyRestApiUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRestApiUrlQuery, GetMyRestApiUrlQueryVariables>(GetMyRestApiUrlDocument, options);
      }
export function useGetMyRestApiUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRestApiUrlQuery, GetMyRestApiUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRestApiUrlQuery, GetMyRestApiUrlQueryVariables>(GetMyRestApiUrlDocument, options);
        }
export function useGetMyRestApiUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyRestApiUrlQuery, GetMyRestApiUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRestApiUrlQuery, GetMyRestApiUrlQueryVariables>(GetMyRestApiUrlDocument, options);
        }
export type GetMyRestApiUrlQueryHookResult = ReturnType<typeof useGetMyRestApiUrlQuery>;
export type GetMyRestApiUrlLazyQueryHookResult = ReturnType<typeof useGetMyRestApiUrlLazyQuery>;
export type GetMyRestApiUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyRestApiUrlSuspenseQuery>;
export type GetMyRestApiUrlQueryResult = Apollo.QueryResult<GetMyRestApiUrlQuery, GetMyRestApiUrlQueryVariables>;
export const GetMyWaffleCfnTemplateDocument = gql`
    query GetMyWaffleCfnTemplate {
  getMyWaffleCfnTemplate
}
    `;

/**
 * __useGetMyWaffleCfnTemplateQuery__
 *
 * To run a query within a React component, call `useGetMyWaffleCfnTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyWaffleCfnTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyWaffleCfnTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyWaffleCfnTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetMyWaffleCfnTemplateQuery, GetMyWaffleCfnTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyWaffleCfnTemplateQuery, GetMyWaffleCfnTemplateQueryVariables>(GetMyWaffleCfnTemplateDocument, options);
      }
export function useGetMyWaffleCfnTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyWaffleCfnTemplateQuery, GetMyWaffleCfnTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyWaffleCfnTemplateQuery, GetMyWaffleCfnTemplateQueryVariables>(GetMyWaffleCfnTemplateDocument, options);
        }
export function useGetMyWaffleCfnTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyWaffleCfnTemplateQuery, GetMyWaffleCfnTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyWaffleCfnTemplateQuery, GetMyWaffleCfnTemplateQueryVariables>(GetMyWaffleCfnTemplateDocument, options);
        }
export type GetMyWaffleCfnTemplateQueryHookResult = ReturnType<typeof useGetMyWaffleCfnTemplateQuery>;
export type GetMyWaffleCfnTemplateLazyQueryHookResult = ReturnType<typeof useGetMyWaffleCfnTemplateLazyQuery>;
export type GetMyWaffleCfnTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMyWaffleCfnTemplateSuspenseQuery>;
export type GetMyWaffleCfnTemplateQueryResult = Apollo.QueryResult<GetMyWaffleCfnTemplateQuery, GetMyWaffleCfnTemplateQueryVariables>;
export const GetMyAlertsStackStatusDocument = gql`
    query getMyAlertsStackStatus($deploymentId: String!) {
  getMyAlertsStackStatus(deploymentId: $deploymentId) {
    id
    stackId
    status
    parametersJSON
  }
}
    `;

/**
 * __useGetMyAlertsStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyAlertsStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAlertsStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAlertsStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyAlertsStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyAlertsStackStatusQuery, GetMyAlertsStackStatusQueryVariables> & ({ variables: GetMyAlertsStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAlertsStackStatusQuery, GetMyAlertsStackStatusQueryVariables>(GetMyAlertsStackStatusDocument, options);
      }
export function useGetMyAlertsStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAlertsStackStatusQuery, GetMyAlertsStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAlertsStackStatusQuery, GetMyAlertsStackStatusQueryVariables>(GetMyAlertsStackStatusDocument, options);
        }
export function useGetMyAlertsStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAlertsStackStatusQuery, GetMyAlertsStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAlertsStackStatusQuery, GetMyAlertsStackStatusQueryVariables>(GetMyAlertsStackStatusDocument, options);
        }
export type GetMyAlertsStackStatusQueryHookResult = ReturnType<typeof useGetMyAlertsStackStatusQuery>;
export type GetMyAlertsStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyAlertsStackStatusLazyQuery>;
export type GetMyAlertsStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyAlertsStackStatusSuspenseQuery>;
export type GetMyAlertsStackStatusQueryResult = Apollo.QueryResult<GetMyAlertsStackStatusQuery, GetMyAlertsStackStatusQueryVariables>;
export const GetMyAuthenticationStackStatusDocument = gql`
    query getMyAuthenticationStackStatus($deploymentId: String!) {
  getMyAuthenticationStackStatus(deploymentId: $deploymentId) {
    id
    stackId
    status
    parametersJSON
  }
}
    `;

/**
 * __useGetMyAuthenticationStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyAuthenticationStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAuthenticationStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAuthenticationStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyAuthenticationStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyAuthenticationStackStatusQuery, GetMyAuthenticationStackStatusQueryVariables> & ({ variables: GetMyAuthenticationStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAuthenticationStackStatusQuery, GetMyAuthenticationStackStatusQueryVariables>(GetMyAuthenticationStackStatusDocument, options);
      }
export function useGetMyAuthenticationStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAuthenticationStackStatusQuery, GetMyAuthenticationStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAuthenticationStackStatusQuery, GetMyAuthenticationStackStatusQueryVariables>(GetMyAuthenticationStackStatusDocument, options);
        }
export function useGetMyAuthenticationStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAuthenticationStackStatusQuery, GetMyAuthenticationStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAuthenticationStackStatusQuery, GetMyAuthenticationStackStatusQueryVariables>(GetMyAuthenticationStackStatusDocument, options);
        }
export type GetMyAuthenticationStackStatusQueryHookResult = ReturnType<typeof useGetMyAuthenticationStackStatusQuery>;
export type GetMyAuthenticationStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyAuthenticationStackStatusLazyQuery>;
export type GetMyAuthenticationStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyAuthenticationStackStatusSuspenseQuery>;
export type GetMyAuthenticationStackStatusQueryResult = Apollo.QueryResult<GetMyAuthenticationStackStatusQuery, GetMyAuthenticationStackStatusQueryVariables>;
export const GetMyDeploymentsStackStatusDocument = gql`
    query getMyDeploymentsStackStatus($deploymentId: String!) {
  getMyDeploymentsStackStatus(deploymentId: $deploymentId) {
    id
    stackId
    status
    parametersJSON
  }
}
    `;

/**
 * __useGetMyDeploymentsStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyDeploymentsStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDeploymentsStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDeploymentsStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyDeploymentsStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyDeploymentsStackStatusQuery, GetMyDeploymentsStackStatusQueryVariables> & ({ variables: GetMyDeploymentsStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDeploymentsStackStatusQuery, GetMyDeploymentsStackStatusQueryVariables>(GetMyDeploymentsStackStatusDocument, options);
      }
export function useGetMyDeploymentsStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDeploymentsStackStatusQuery, GetMyDeploymentsStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDeploymentsStackStatusQuery, GetMyDeploymentsStackStatusQueryVariables>(GetMyDeploymentsStackStatusDocument, options);
        }
export function useGetMyDeploymentsStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDeploymentsStackStatusQuery, GetMyDeploymentsStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDeploymentsStackStatusQuery, GetMyDeploymentsStackStatusQueryVariables>(GetMyDeploymentsStackStatusDocument, options);
        }
export type GetMyDeploymentsStackStatusQueryHookResult = ReturnType<typeof useGetMyDeploymentsStackStatusQuery>;
export type GetMyDeploymentsStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyDeploymentsStackStatusLazyQuery>;
export type GetMyDeploymentsStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyDeploymentsStackStatusSuspenseQuery>;
export type GetMyDeploymentsStackStatusQueryResult = Apollo.QueryResult<GetMyDeploymentsStackStatusQuery, GetMyDeploymentsStackStatusQueryVariables>;
export const GetMyHttpApiV2StackStatusDocument = gql`
    query getMyHttpApiV2StackStatus($deploymentId: String!) {
  getMyHttpApiV2StackStatus(deploymentId: $deploymentId) {
    id
    stackId
    status
    parametersJSON
  }
}
    `;

/**
 * __useGetMyHttpApiV2StackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyHttpApiV2StackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyHttpApiV2StackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyHttpApiV2StackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyHttpApiV2StackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyHttpApiV2StackStatusQuery, GetMyHttpApiV2StackStatusQueryVariables> & ({ variables: GetMyHttpApiV2StackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyHttpApiV2StackStatusQuery, GetMyHttpApiV2StackStatusQueryVariables>(GetMyHttpApiV2StackStatusDocument, options);
      }
export function useGetMyHttpApiV2StackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyHttpApiV2StackStatusQuery, GetMyHttpApiV2StackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyHttpApiV2StackStatusQuery, GetMyHttpApiV2StackStatusQueryVariables>(GetMyHttpApiV2StackStatusDocument, options);
        }
export function useGetMyHttpApiV2StackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyHttpApiV2StackStatusQuery, GetMyHttpApiV2StackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyHttpApiV2StackStatusQuery, GetMyHttpApiV2StackStatusQueryVariables>(GetMyHttpApiV2StackStatusDocument, options);
        }
export type GetMyHttpApiV2StackStatusQueryHookResult = ReturnType<typeof useGetMyHttpApiV2StackStatusQuery>;
export type GetMyHttpApiV2StackStatusLazyQueryHookResult = ReturnType<typeof useGetMyHttpApiV2StackStatusLazyQuery>;
export type GetMyHttpApiV2StackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyHttpApiV2StackStatusSuspenseQuery>;
export type GetMyHttpApiV2StackStatusQueryResult = Apollo.QueryResult<GetMyHttpApiV2StackStatusQuery, GetMyHttpApiV2StackStatusQueryVariables>;
export const GetMyRestApiV1StackStatusDocument = gql`
    query getMyRestApiV1StackStatus($deploymentId: String!) {
  getMyRestApiV1StackStatus(deploymentId: $deploymentId) {
    id
    stackId
    status
    parametersJSON
  }
}
    `;

/**
 * __useGetMyRestApiV1StackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyRestApiV1StackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRestApiV1StackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRestApiV1StackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyRestApiV1StackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyRestApiV1StackStatusQuery, GetMyRestApiV1StackStatusQueryVariables> & ({ variables: GetMyRestApiV1StackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRestApiV1StackStatusQuery, GetMyRestApiV1StackStatusQueryVariables>(GetMyRestApiV1StackStatusDocument, options);
      }
export function useGetMyRestApiV1StackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRestApiV1StackStatusQuery, GetMyRestApiV1StackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRestApiV1StackStatusQuery, GetMyRestApiV1StackStatusQueryVariables>(GetMyRestApiV1StackStatusDocument, options);
        }
export function useGetMyRestApiV1StackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyRestApiV1StackStatusQuery, GetMyRestApiV1StackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRestApiV1StackStatusQuery, GetMyRestApiV1StackStatusQueryVariables>(GetMyRestApiV1StackStatusDocument, options);
        }
export type GetMyRestApiV1StackStatusQueryHookResult = ReturnType<typeof useGetMyRestApiV1StackStatusQuery>;
export type GetMyRestApiV1StackStatusLazyQueryHookResult = ReturnType<typeof useGetMyRestApiV1StackStatusLazyQuery>;
export type GetMyRestApiV1StackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyRestApiV1StackStatusSuspenseQuery>;
export type GetMyRestApiV1StackStatusQueryResult = Apollo.QueryResult<GetMyRestApiV1StackStatusQuery, GetMyRestApiV1StackStatusQueryVariables>;
export const GetMyVpcStackStatusDocument = gql`
    query getMyVpcStackStatus($deploymentId: String!) {
  getMyVpcStackStatus(deploymentId: $deploymentId) {
    id
    stackId
    status
    parametersJSON
  }
}
    `;

/**
 * __useGetMyVpcStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyVpcStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVpcStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVpcStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyVpcStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyVpcStackStatusQuery, GetMyVpcStackStatusQueryVariables> & ({ variables: GetMyVpcStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyVpcStackStatusQuery, GetMyVpcStackStatusQueryVariables>(GetMyVpcStackStatusDocument, options);
      }
export function useGetMyVpcStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyVpcStackStatusQuery, GetMyVpcStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyVpcStackStatusQuery, GetMyVpcStackStatusQueryVariables>(GetMyVpcStackStatusDocument, options);
        }
export function useGetMyVpcStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyVpcStackStatusQuery, GetMyVpcStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyVpcStackStatusQuery, GetMyVpcStackStatusQueryVariables>(GetMyVpcStackStatusDocument, options);
        }
export type GetMyVpcStackStatusQueryHookResult = ReturnType<typeof useGetMyVpcStackStatusQuery>;
export type GetMyVpcStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyVpcStackStatusLazyQuery>;
export type GetMyVpcStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyVpcStackStatusSuspenseQuery>;
export type GetMyVpcStackStatusQueryResult = Apollo.QueryResult<GetMyVpcStackStatusQuery, GetMyVpcStackStatusQueryVariables>;
export const TempTestMyWaffleRoleDocument = gql`
    mutation TempTestMyWaffleRole($accountId: String!) {
  tempTestMyWaffleRole(accountId: $accountId) {
    id
    passed
    details
  }
}
    `;
export type TempTestMyWaffleRoleMutationFn = Apollo.MutationFunction<TempTestMyWaffleRoleMutation, TempTestMyWaffleRoleMutationVariables>;

/**
 * __useTempTestMyWaffleRoleMutation__
 *
 * To run a mutation, you first call `useTempTestMyWaffleRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTempTestMyWaffleRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tempTestMyWaffleRoleMutation, { data, loading, error }] = useTempTestMyWaffleRoleMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useTempTestMyWaffleRoleMutation(baseOptions?: Apollo.MutationHookOptions<TempTestMyWaffleRoleMutation, TempTestMyWaffleRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TempTestMyWaffleRoleMutation, TempTestMyWaffleRoleMutationVariables>(TempTestMyWaffleRoleDocument, options);
      }
export type TempTestMyWaffleRoleMutationHookResult = ReturnType<typeof useTempTestMyWaffleRoleMutation>;
export type TempTestMyWaffleRoleMutationResult = Apollo.MutationResult<TempTestMyWaffleRoleMutation>;
export type TempTestMyWaffleRoleMutationOptions = Apollo.BaseMutationOptions<TempTestMyWaffleRoleMutation, TempTestMyWaffleRoleMutationVariables>;
export const TestMyWaffleRoleDocument = gql`
    query TestMyWaffleRole($deploymentId: String!) {
  testMyWaffleRole(deploymentId: $deploymentId) {
    id
    passed
    details
  }
}
    `;

/**
 * __useTestMyWaffleRoleQuery__
 *
 * To run a query within a React component, call `useTestMyWaffleRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestMyWaffleRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestMyWaffleRoleQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useTestMyWaffleRoleQuery(baseOptions: Apollo.QueryHookOptions<TestMyWaffleRoleQuery, TestMyWaffleRoleQueryVariables> & ({ variables: TestMyWaffleRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestMyWaffleRoleQuery, TestMyWaffleRoleQueryVariables>(TestMyWaffleRoleDocument, options);
      }
export function useTestMyWaffleRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestMyWaffleRoleQuery, TestMyWaffleRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestMyWaffleRoleQuery, TestMyWaffleRoleQueryVariables>(TestMyWaffleRoleDocument, options);
        }
export function useTestMyWaffleRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TestMyWaffleRoleQuery, TestMyWaffleRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestMyWaffleRoleQuery, TestMyWaffleRoleQueryVariables>(TestMyWaffleRoleDocument, options);
        }
export type TestMyWaffleRoleQueryHookResult = ReturnType<typeof useTestMyWaffleRoleQuery>;
export type TestMyWaffleRoleLazyQueryHookResult = ReturnType<typeof useTestMyWaffleRoleLazyQuery>;
export type TestMyWaffleRoleSuspenseQueryHookResult = ReturnType<typeof useTestMyWaffleRoleSuspenseQuery>;
export type TestMyWaffleRoleQueryResult = Apollo.QueryResult<TestMyWaffleRoleQuery, TestMyWaffleRoleQueryVariables>;
export const HelloWorldDocument = gql`
    query HelloWorld {
  helloWorld
}
    `;

/**
 * __useHelloWorldQuery__
 *
 * To run a query within a React component, call `useHelloWorldQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelloWorldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelloWorldQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelloWorldQuery(baseOptions?: Apollo.QueryHookOptions<HelloWorldQuery, HelloWorldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelloWorldQuery, HelloWorldQueryVariables>(HelloWorldDocument, options);
      }
export function useHelloWorldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelloWorldQuery, HelloWorldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelloWorldQuery, HelloWorldQueryVariables>(HelloWorldDocument, options);
        }
export function useHelloWorldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HelloWorldQuery, HelloWorldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HelloWorldQuery, HelloWorldQueryVariables>(HelloWorldDocument, options);
        }
export type HelloWorldQueryHookResult = ReturnType<typeof useHelloWorldQuery>;
export type HelloWorldLazyQueryHookResult = ReturnType<typeof useHelloWorldLazyQuery>;
export type HelloWorldSuspenseQueryHookResult = ReturnType<typeof useHelloWorldSuspenseQuery>;
export type HelloWorldQueryResult = Apollo.QueryResult<HelloWorldQuery, HelloWorldQueryVariables>;
export const AddOrganizationDocument = gql`
    mutation AddOrganization($organizationId: String!) {
  addOrganization(organizationId: $organizationId) {
    id
    name
  }
}
    `;
export type AddOrganizationMutationFn = Apollo.MutationFunction<AddOrganizationMutation, AddOrganizationMutationVariables>;

/**
 * __useAddOrganizationMutation__
 *
 * To run a mutation, you first call `useAddOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationMutation, { data, loading, error }] = useAddOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAddOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationMutation, AddOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationMutation, AddOrganizationMutationVariables>(AddOrganizationDocument, options);
      }
export type AddOrganizationMutationHookResult = ReturnType<typeof useAddOrganizationMutation>;
export type AddOrganizationMutationResult = Apollo.MutationResult<AddOrganizationMutation>;
export type AddOrganizationMutationOptions = Apollo.BaseMutationOptions<AddOrganizationMutation, AddOrganizationMutationVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($organizationInput: EditOrganization!) {
  editOrganization(organizationInput: $organizationInput) {
    id
    name
    features {
      workInProgressFeaturesEnabled
      envFeaturesStackEnabled
      singleDeployment
      databaseEnabled
      apiV1Enabled
      wsApiEnabled
      httpApiEnabled
      customDomainEnabled
    }
    onboardingComplete
  }
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      organizationInput: // value for 'organizationInput'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const GetAllOrganizationsDocument = gql`
    query GetAllOrganizations {
  getAllOrganizations {
    id
    name
  }
}
    `;

/**
 * __useGetAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(GetAllOrganizationsDocument, options);
      }
export function useGetAllOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(GetAllOrganizationsDocument, options);
        }
export function useGetAllOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(GetAllOrganizationsDocument, options);
        }
export type GetAllOrganizationsQueryHookResult = ReturnType<typeof useGetAllOrganizationsQuery>;
export type GetAllOrganizationsLazyQueryHookResult = ReturnType<typeof useGetAllOrganizationsLazyQuery>;
export type GetAllOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetAllOrganizationsSuspenseQuery>;
export type GetAllOrganizationsQueryResult = Apollo.QueryResult<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>;
export const GetMyOrganizationDocument = gql`
    query GetMyOrganization {
  getMyOrganization {
    name
    id
    features {
      workInProgressFeaturesEnabled
      envFeaturesStackEnabled
      singleDeployment
      databaseEnabled
      apiV1Enabled
      wsApiEnabled
      httpApiEnabled
      customDomainEnabled
    }
    onboardingComplete
  }
}
    `;

/**
 * __useGetMyOrganizationQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrganizationQuery, GetMyOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrganizationQuery, GetMyOrganizationQueryVariables>(GetMyOrganizationDocument, options);
      }
export function useGetMyOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrganizationQuery, GetMyOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrganizationQuery, GetMyOrganizationQueryVariables>(GetMyOrganizationDocument, options);
        }
export function useGetMyOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyOrganizationQuery, GetMyOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOrganizationQuery, GetMyOrganizationQueryVariables>(GetMyOrganizationDocument, options);
        }
export type GetMyOrganizationQueryHookResult = ReturnType<typeof useGetMyOrganizationQuery>;
export type GetMyOrganizationLazyQueryHookResult = ReturnType<typeof useGetMyOrganizationLazyQuery>;
export type GetMyOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetMyOrganizationSuspenseQuery>;
export type GetMyOrganizationQueryResult = Apollo.QueryResult<GetMyOrganizationQuery, GetMyOrganizationQueryVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization($organizationId: String!) {
  getOrganization(organizationId: $organizationId) {
    id
    name
    features {
      workInProgressFeaturesEnabled
      envFeaturesStackEnabled
      singleDeployment
      databaseEnabled
      apiV1Enabled
      wsApiEnabled
      httpApiEnabled
      customDomainEnabled
    }
    onboardingComplete
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const SetMyOnboardingCompleteDocument = gql`
    mutation SetMyOnboardingComplete($complete: Boolean!) {
  setMyOnboardingComplete(complete: $complete)
}
    `;
export type SetMyOnboardingCompleteMutationFn = Apollo.MutationFunction<SetMyOnboardingCompleteMutation, SetMyOnboardingCompleteMutationVariables>;

/**
 * __useSetMyOnboardingCompleteMutation__
 *
 * To run a mutation, you first call `useSetMyOnboardingCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyOnboardingCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyOnboardingCompleteMutation, { data, loading, error }] = useSetMyOnboardingCompleteMutation({
 *   variables: {
 *      complete: // value for 'complete'
 *   },
 * });
 */
export function useSetMyOnboardingCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SetMyOnboardingCompleteMutation, SetMyOnboardingCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyOnboardingCompleteMutation, SetMyOnboardingCompleteMutationVariables>(SetMyOnboardingCompleteDocument, options);
      }
export type SetMyOnboardingCompleteMutationHookResult = ReturnType<typeof useSetMyOnboardingCompleteMutation>;
export type SetMyOnboardingCompleteMutationResult = Apollo.MutationResult<SetMyOnboardingCompleteMutation>;
export type SetMyOnboardingCompleteMutationOptions = Apollo.BaseMutationOptions<SetMyOnboardingCompleteMutation, SetMyOnboardingCompleteMutationVariables>;
export const AddMyServiceStackDocument = gql`
    mutation AddMyServiceStack($stackId: String!, $type: String!) {
  addMyServiceStack(stackId: $stackId, type: $type) {
    id
    name
    type
  }
}
    `;
export type AddMyServiceStackMutationFn = Apollo.MutationFunction<AddMyServiceStackMutation, AddMyServiceStackMutationVariables>;

/**
 * __useAddMyServiceStackMutation__
 *
 * To run a mutation, you first call `useAddMyServiceStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMyServiceStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMyServiceStackMutation, { data, loading, error }] = useAddMyServiceStackMutation({
 *   variables: {
 *      stackId: // value for 'stackId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddMyServiceStackMutation(baseOptions?: Apollo.MutationHookOptions<AddMyServiceStackMutation, AddMyServiceStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMyServiceStackMutation, AddMyServiceStackMutationVariables>(AddMyServiceStackDocument, options);
      }
export type AddMyServiceStackMutationHookResult = ReturnType<typeof useAddMyServiceStackMutation>;
export type AddMyServiceStackMutationResult = Apollo.MutationResult<AddMyServiceStackMutation>;
export type AddMyServiceStackMutationOptions = Apollo.BaseMutationOptions<AddMyServiceStackMutation, AddMyServiceStackMutationVariables>;
export const DeployMyAnyCfnStackDocument = gql`
    mutation deployMyAnyCfnStack($stackDeploymentInput: DeployAnyCfnStack!) {
  deployMyAnyCfnStack(stackDeploymentInput: $stackDeploymentInput)
}
    `;
export type DeployMyAnyCfnStackMutationFn = Apollo.MutationFunction<DeployMyAnyCfnStackMutation, DeployMyAnyCfnStackMutationVariables>;

/**
 * __useDeployMyAnyCfnStackMutation__
 *
 * To run a mutation, you first call `useDeployMyAnyCfnStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyAnyCfnStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyAnyCfnStackMutation, { data, loading, error }] = useDeployMyAnyCfnStackMutation({
 *   variables: {
 *      stackDeploymentInput: // value for 'stackDeploymentInput'
 *   },
 * });
 */
export function useDeployMyAnyCfnStackMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyAnyCfnStackMutation, DeployMyAnyCfnStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyAnyCfnStackMutation, DeployMyAnyCfnStackMutationVariables>(DeployMyAnyCfnStackDocument, options);
      }
export type DeployMyAnyCfnStackMutationHookResult = ReturnType<typeof useDeployMyAnyCfnStackMutation>;
export type DeployMyAnyCfnStackMutationResult = Apollo.MutationResult<DeployMyAnyCfnStackMutation>;
export type DeployMyAnyCfnStackMutationOptions = Apollo.BaseMutationOptions<DeployMyAnyCfnStackMutation, DeployMyAnyCfnStackMutationVariables>;
export const DeployMyCdnStackDocument = gql`
    mutation DeployMyCdnStack($stackDeploymentInput: DeployCdnStack!) {
  deployMyCdnStack(stackDeploymentInput: $stackDeploymentInput)
}
    `;
export type DeployMyCdnStackMutationFn = Apollo.MutationFunction<DeployMyCdnStackMutation, DeployMyCdnStackMutationVariables>;

/**
 * __useDeployMyCdnStackMutation__
 *
 * To run a mutation, you first call `useDeployMyCdnStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyCdnStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyCdnStackMutation, { data, loading, error }] = useDeployMyCdnStackMutation({
 *   variables: {
 *      stackDeploymentInput: // value for 'stackDeploymentInput'
 *   },
 * });
 */
export function useDeployMyCdnStackMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyCdnStackMutation, DeployMyCdnStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyCdnStackMutation, DeployMyCdnStackMutationVariables>(DeployMyCdnStackDocument, options);
      }
export type DeployMyCdnStackMutationHookResult = ReturnType<typeof useDeployMyCdnStackMutation>;
export type DeployMyCdnStackMutationResult = Apollo.MutationResult<DeployMyCdnStackMutation>;
export type DeployMyCdnStackMutationOptions = Apollo.BaseMutationOptions<DeployMyCdnStackMutation, DeployMyCdnStackMutationVariables>;
export const DeployMyCfnStackDocument = gql`
    mutation DeployMyCfnStack($stackDeploymentInput: DeployCfnStack!) {
  deployMyCfnStack(stackDeploymentInput: $stackDeploymentInput)
}
    `;
export type DeployMyCfnStackMutationFn = Apollo.MutationFunction<DeployMyCfnStackMutation, DeployMyCfnStackMutationVariables>;

/**
 * __useDeployMyCfnStackMutation__
 *
 * To run a mutation, you first call `useDeployMyCfnStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyCfnStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyCfnStackMutation, { data, loading, error }] = useDeployMyCfnStackMutation({
 *   variables: {
 *      stackDeploymentInput: // value for 'stackDeploymentInput'
 *   },
 * });
 */
export function useDeployMyCfnStackMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyCfnStackMutation, DeployMyCfnStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyCfnStackMutation, DeployMyCfnStackMutationVariables>(DeployMyCfnStackDocument, options);
      }
export type DeployMyCfnStackMutationHookResult = ReturnType<typeof useDeployMyCfnStackMutation>;
export type DeployMyCfnStackMutationResult = Apollo.MutationResult<DeployMyCfnStackMutation>;
export type DeployMyCfnStackMutationOptions = Apollo.BaseMutationOptions<DeployMyCfnStackMutation, DeployMyCfnStackMutationVariables>;
export const DeployMyDbStackDocument = gql`
    mutation DeployMyDbStack($stackDeploymentInput: DeployDbStack!) {
  deployMyDbStack(stackDeploymentInput: $stackDeploymentInput)
}
    `;
export type DeployMyDbStackMutationFn = Apollo.MutationFunction<DeployMyDbStackMutation, DeployMyDbStackMutationVariables>;

/**
 * __useDeployMyDbStackMutation__
 *
 * To run a mutation, you first call `useDeployMyDbStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyDbStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyDbStackMutation, { data, loading, error }] = useDeployMyDbStackMutation({
 *   variables: {
 *      stackDeploymentInput: // value for 'stackDeploymentInput'
 *   },
 * });
 */
export function useDeployMyDbStackMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyDbStackMutation, DeployMyDbStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyDbStackMutation, DeployMyDbStackMutationVariables>(DeployMyDbStackDocument, options);
      }
export type DeployMyDbStackMutationHookResult = ReturnType<typeof useDeployMyDbStackMutation>;
export type DeployMyDbStackMutationResult = Apollo.MutationResult<DeployMyDbStackMutation>;
export type DeployMyDbStackMutationOptions = Apollo.BaseMutationOptions<DeployMyDbStackMutation, DeployMyDbStackMutationVariables>;
export const DeployMyEcsFargateStackDocument = gql`
    mutation DeployMyEcsFargateStack($stackDeploymentInput: DeployEcsFargateStack!) {
  deployMyEcsFargateStack(stackDeploymentInput: $stackDeploymentInput)
}
    `;
export type DeployMyEcsFargateStackMutationFn = Apollo.MutationFunction<DeployMyEcsFargateStackMutation, DeployMyEcsFargateStackMutationVariables>;

/**
 * __useDeployMyEcsFargateStackMutation__
 *
 * To run a mutation, you first call `useDeployMyEcsFargateStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyEcsFargateStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyEcsFargateStackMutation, { data, loading, error }] = useDeployMyEcsFargateStackMutation({
 *   variables: {
 *      stackDeploymentInput: // value for 'stackDeploymentInput'
 *   },
 * });
 */
export function useDeployMyEcsFargateStackMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyEcsFargateStackMutation, DeployMyEcsFargateStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyEcsFargateStackMutation, DeployMyEcsFargateStackMutationVariables>(DeployMyEcsFargateStackDocument, options);
      }
export type DeployMyEcsFargateStackMutationHookResult = ReturnType<typeof useDeployMyEcsFargateStackMutation>;
export type DeployMyEcsFargateStackMutationResult = Apollo.MutationResult<DeployMyEcsFargateStackMutation>;
export type DeployMyEcsFargateStackMutationOptions = Apollo.BaseMutationOptions<DeployMyEcsFargateStackMutation, DeployMyEcsFargateStackMutationVariables>;
export const DeployMyEcsWsFargateStackDocument = gql`
    mutation DeployMyEcsWsFargateStack($stackDeploymentInput: DeployEcsWsFargateStack!) {
  deployMyEcsWsFargateStack(stackDeploymentInput: $stackDeploymentInput)
}
    `;
export type DeployMyEcsWsFargateStackMutationFn = Apollo.MutationFunction<DeployMyEcsWsFargateStackMutation, DeployMyEcsWsFargateStackMutationVariables>;

/**
 * __useDeployMyEcsWsFargateStackMutation__
 *
 * To run a mutation, you first call `useDeployMyEcsWsFargateStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployMyEcsWsFargateStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployMyEcsWsFargateStackMutation, { data, loading, error }] = useDeployMyEcsWsFargateStackMutation({
 *   variables: {
 *      stackDeploymentInput: // value for 'stackDeploymentInput'
 *   },
 * });
 */
export function useDeployMyEcsWsFargateStackMutation(baseOptions?: Apollo.MutationHookOptions<DeployMyEcsWsFargateStackMutation, DeployMyEcsWsFargateStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployMyEcsWsFargateStackMutation, DeployMyEcsWsFargateStackMutationVariables>(DeployMyEcsWsFargateStackDocument, options);
      }
export type DeployMyEcsWsFargateStackMutationHookResult = ReturnType<typeof useDeployMyEcsWsFargateStackMutation>;
export type DeployMyEcsWsFargateStackMutationResult = Apollo.MutationResult<DeployMyEcsWsFargateStackMutation>;
export type DeployMyEcsWsFargateStackMutationOptions = Apollo.BaseMutationOptions<DeployMyEcsWsFargateStackMutation, DeployMyEcsWsFargateStackMutationVariables>;
export const EditMyServiceStackDocument = gql`
    mutation EditMyServiceStack($stackInput: EditServiceStack!) {
  editMyServiceStack(stackInput: $stackInput) {
    id
    name
    type
  }
}
    `;
export type EditMyServiceStackMutationFn = Apollo.MutationFunction<EditMyServiceStackMutation, EditMyServiceStackMutationVariables>;

/**
 * __useEditMyServiceStackMutation__
 *
 * To run a mutation, you first call `useEditMyServiceStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMyServiceStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMyServiceStackMutation, { data, loading, error }] = useEditMyServiceStackMutation({
 *   variables: {
 *      stackInput: // value for 'stackInput'
 *   },
 * });
 */
export function useEditMyServiceStackMutation(baseOptions?: Apollo.MutationHookOptions<EditMyServiceStackMutation, EditMyServiceStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMyServiceStackMutation, EditMyServiceStackMutationVariables>(EditMyServiceStackDocument, options);
      }
export type EditMyServiceStackMutationHookResult = ReturnType<typeof useEditMyServiceStackMutation>;
export type EditMyServiceStackMutationResult = Apollo.MutationResult<EditMyServiceStackMutation>;
export type EditMyServiceStackMutationOptions = Apollo.BaseMutationOptions<EditMyServiceStackMutation, EditMyServiceStackMutationVariables>;
export const GetMyCdnServiceStackPublicUrlDocument = gql`
    query getMyCdnServiceStackPublicUrl($deploymentId: String!, $pipelineId: String!) {
  getMyCdnServiceStackPublicUrl(
    deploymentId: $deploymentId
    pipelineId: $pipelineId
  )
}
    `;

/**
 * __useGetMyCdnServiceStackPublicUrlQuery__
 *
 * To run a query within a React component, call `useGetMyCdnServiceStackPublicUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCdnServiceStackPublicUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCdnServiceStackPublicUrlQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useGetMyCdnServiceStackPublicUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyCdnServiceStackPublicUrlQuery, GetMyCdnServiceStackPublicUrlQueryVariables> & ({ variables: GetMyCdnServiceStackPublicUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCdnServiceStackPublicUrlQuery, GetMyCdnServiceStackPublicUrlQueryVariables>(GetMyCdnServiceStackPublicUrlDocument, options);
      }
export function useGetMyCdnServiceStackPublicUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCdnServiceStackPublicUrlQuery, GetMyCdnServiceStackPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCdnServiceStackPublicUrlQuery, GetMyCdnServiceStackPublicUrlQueryVariables>(GetMyCdnServiceStackPublicUrlDocument, options);
        }
export function useGetMyCdnServiceStackPublicUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCdnServiceStackPublicUrlQuery, GetMyCdnServiceStackPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCdnServiceStackPublicUrlQuery, GetMyCdnServiceStackPublicUrlQueryVariables>(GetMyCdnServiceStackPublicUrlDocument, options);
        }
export type GetMyCdnServiceStackPublicUrlQueryHookResult = ReturnType<typeof useGetMyCdnServiceStackPublicUrlQuery>;
export type GetMyCdnServiceStackPublicUrlLazyQueryHookResult = ReturnType<typeof useGetMyCdnServiceStackPublicUrlLazyQuery>;
export type GetMyCdnServiceStackPublicUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyCdnServiceStackPublicUrlSuspenseQuery>;
export type GetMyCdnServiceStackPublicUrlQueryResult = Apollo.QueryResult<GetMyCdnServiceStackPublicUrlQuery, GetMyCdnServiceStackPublicUrlQueryVariables>;
export const GetMyCdnServiceStackStatusDocument = gql`
    query GetMyCdnServiceStackStatus($deploymentId: String!, $pipelineId: String!, $stackId: String) {
  getMyCdnServiceStackStatus(
    deploymentId: $deploymentId
    pipelineId: $pipelineId
    stackId: $stackId
  ) {
    id
    status
    parametersJSON
    stackId
  }
}
    `;

/**
 * __useGetMyCdnServiceStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyCdnServiceStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCdnServiceStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCdnServiceStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyCdnServiceStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyCdnServiceStackStatusQuery, GetMyCdnServiceStackStatusQueryVariables> & ({ variables: GetMyCdnServiceStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCdnServiceStackStatusQuery, GetMyCdnServiceStackStatusQueryVariables>(GetMyCdnServiceStackStatusDocument, options);
      }
export function useGetMyCdnServiceStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCdnServiceStackStatusQuery, GetMyCdnServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCdnServiceStackStatusQuery, GetMyCdnServiceStackStatusQueryVariables>(GetMyCdnServiceStackStatusDocument, options);
        }
export function useGetMyCdnServiceStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCdnServiceStackStatusQuery, GetMyCdnServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCdnServiceStackStatusQuery, GetMyCdnServiceStackStatusQueryVariables>(GetMyCdnServiceStackStatusDocument, options);
        }
export type GetMyCdnServiceStackStatusQueryHookResult = ReturnType<typeof useGetMyCdnServiceStackStatusQuery>;
export type GetMyCdnServiceStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyCdnServiceStackStatusLazyQuery>;
export type GetMyCdnServiceStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyCdnServiceStackStatusSuspenseQuery>;
export type GetMyCdnServiceStackStatusQueryResult = Apollo.QueryResult<GetMyCdnServiceStackStatusQuery, GetMyCdnServiceStackStatusQueryVariables>;
export const GetMyCfnServiceStackStatusDocument = gql`
    query GetMyCfnServiceStackStatus($deploymentId: String!, $pipelineId: String!, $stackId: String) {
  getMyCfnServiceStackStatus(
    deploymentId: $deploymentId
    pipelineId: $pipelineId
    stackId: $stackId
  ) {
    id
    status
    parametersJSON
    stackId
  }
}
    `;

/**
 * __useGetMyCfnServiceStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyCfnServiceStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCfnServiceStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCfnServiceStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyCfnServiceStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyCfnServiceStackStatusQuery, GetMyCfnServiceStackStatusQueryVariables> & ({ variables: GetMyCfnServiceStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCfnServiceStackStatusQuery, GetMyCfnServiceStackStatusQueryVariables>(GetMyCfnServiceStackStatusDocument, options);
      }
export function useGetMyCfnServiceStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCfnServiceStackStatusQuery, GetMyCfnServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCfnServiceStackStatusQuery, GetMyCfnServiceStackStatusQueryVariables>(GetMyCfnServiceStackStatusDocument, options);
        }
export function useGetMyCfnServiceStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCfnServiceStackStatusQuery, GetMyCfnServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCfnServiceStackStatusQuery, GetMyCfnServiceStackStatusQueryVariables>(GetMyCfnServiceStackStatusDocument, options);
        }
export type GetMyCfnServiceStackStatusQueryHookResult = ReturnType<typeof useGetMyCfnServiceStackStatusQuery>;
export type GetMyCfnServiceStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyCfnServiceStackStatusLazyQuery>;
export type GetMyCfnServiceStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyCfnServiceStackStatusSuspenseQuery>;
export type GetMyCfnServiceStackStatusQueryResult = Apollo.QueryResult<GetMyCfnServiceStackStatusQuery, GetMyCfnServiceStackStatusQueryVariables>;
export const GetMyCfnStackIdsDocument = gql`
    query getMyCfnStackIds($deploymentId: String!) {
  getMyCfnStackIds(deploymentId: $deploymentId)
}
    `;

/**
 * __useGetMyCfnStackIdsQuery__
 *
 * To run a query within a React component, call `useGetMyCfnStackIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCfnStackIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCfnStackIdsQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyCfnStackIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMyCfnStackIdsQuery, GetMyCfnStackIdsQueryVariables> & ({ variables: GetMyCfnStackIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCfnStackIdsQuery, GetMyCfnStackIdsQueryVariables>(GetMyCfnStackIdsDocument, options);
      }
export function useGetMyCfnStackIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCfnStackIdsQuery, GetMyCfnStackIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCfnStackIdsQuery, GetMyCfnStackIdsQueryVariables>(GetMyCfnStackIdsDocument, options);
        }
export function useGetMyCfnStackIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCfnStackIdsQuery, GetMyCfnStackIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCfnStackIdsQuery, GetMyCfnStackIdsQueryVariables>(GetMyCfnStackIdsDocument, options);
        }
export type GetMyCfnStackIdsQueryHookResult = ReturnType<typeof useGetMyCfnStackIdsQuery>;
export type GetMyCfnStackIdsLazyQueryHookResult = ReturnType<typeof useGetMyCfnStackIdsLazyQuery>;
export type GetMyCfnStackIdsSuspenseQueryHookResult = ReturnType<typeof useGetMyCfnStackIdsSuspenseQuery>;
export type GetMyCfnStackIdsQueryResult = Apollo.QueryResult<GetMyCfnStackIdsQuery, GetMyCfnStackIdsQueryVariables>;
export const GetMyCfnStackLatestEventsDocument = gql`
    query getMyCfnStackLatestEvents($deploymentId: String!, $stackId: String!) {
  getMyCfnStackLatestEvents(deploymentId: $deploymentId, stackId: $stackId)
}
    `;

/**
 * __useGetMyCfnStackLatestEventsQuery__
 *
 * To run a query within a React component, call `useGetMyCfnStackLatestEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCfnStackLatestEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCfnStackLatestEventsQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyCfnStackLatestEventsQuery(baseOptions: Apollo.QueryHookOptions<GetMyCfnStackLatestEventsQuery, GetMyCfnStackLatestEventsQueryVariables> & ({ variables: GetMyCfnStackLatestEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCfnStackLatestEventsQuery, GetMyCfnStackLatestEventsQueryVariables>(GetMyCfnStackLatestEventsDocument, options);
      }
export function useGetMyCfnStackLatestEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCfnStackLatestEventsQuery, GetMyCfnStackLatestEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCfnStackLatestEventsQuery, GetMyCfnStackLatestEventsQueryVariables>(GetMyCfnStackLatestEventsDocument, options);
        }
export function useGetMyCfnStackLatestEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCfnStackLatestEventsQuery, GetMyCfnStackLatestEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCfnStackLatestEventsQuery, GetMyCfnStackLatestEventsQueryVariables>(GetMyCfnStackLatestEventsDocument, options);
        }
export type GetMyCfnStackLatestEventsQueryHookResult = ReturnType<typeof useGetMyCfnStackLatestEventsQuery>;
export type GetMyCfnStackLatestEventsLazyQueryHookResult = ReturnType<typeof useGetMyCfnStackLatestEventsLazyQuery>;
export type GetMyCfnStackLatestEventsSuspenseQueryHookResult = ReturnType<typeof useGetMyCfnStackLatestEventsSuspenseQuery>;
export type GetMyCfnStackLatestEventsQueryResult = Apollo.QueryResult<GetMyCfnStackLatestEventsQuery, GetMyCfnStackLatestEventsQueryVariables>;
export const GetMyCfnStackParametersDocument = gql`
    query getMyCfnStackParameters($deploymentId: String!, $stackId: String!) {
  getMyCfnStackParameters(deploymentId: $deploymentId, stackId: $stackId)
}
    `;

/**
 * __useGetMyCfnStackParametersQuery__
 *
 * To run a query within a React component, call `useGetMyCfnStackParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCfnStackParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCfnStackParametersQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyCfnStackParametersQuery(baseOptions: Apollo.QueryHookOptions<GetMyCfnStackParametersQuery, GetMyCfnStackParametersQueryVariables> & ({ variables: GetMyCfnStackParametersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCfnStackParametersQuery, GetMyCfnStackParametersQueryVariables>(GetMyCfnStackParametersDocument, options);
      }
export function useGetMyCfnStackParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCfnStackParametersQuery, GetMyCfnStackParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCfnStackParametersQuery, GetMyCfnStackParametersQueryVariables>(GetMyCfnStackParametersDocument, options);
        }
export function useGetMyCfnStackParametersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCfnStackParametersQuery, GetMyCfnStackParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCfnStackParametersQuery, GetMyCfnStackParametersQueryVariables>(GetMyCfnStackParametersDocument, options);
        }
export type GetMyCfnStackParametersQueryHookResult = ReturnType<typeof useGetMyCfnStackParametersQuery>;
export type GetMyCfnStackParametersLazyQueryHookResult = ReturnType<typeof useGetMyCfnStackParametersLazyQuery>;
export type GetMyCfnStackParametersSuspenseQueryHookResult = ReturnType<typeof useGetMyCfnStackParametersSuspenseQuery>;
export type GetMyCfnStackParametersQueryResult = Apollo.QueryResult<GetMyCfnStackParametersQuery, GetMyCfnStackParametersQueryVariables>;
export const GetMyCfnStackStatusDocument = gql`
    query getMyCfnStackStatus($deploymentId: String!, $stackId: String!) {
  getMyCfnStackStatus(deploymentId: $deploymentId, stackId: $stackId) {
    id
    status
    parametersJSON
    stackId
    fullDetails
  }
}
    `;

/**
 * __useGetMyCfnStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyCfnStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCfnStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCfnStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyCfnStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyCfnStackStatusQuery, GetMyCfnStackStatusQueryVariables> & ({ variables: GetMyCfnStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCfnStackStatusQuery, GetMyCfnStackStatusQueryVariables>(GetMyCfnStackStatusDocument, options);
      }
export function useGetMyCfnStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCfnStackStatusQuery, GetMyCfnStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCfnStackStatusQuery, GetMyCfnStackStatusQueryVariables>(GetMyCfnStackStatusDocument, options);
        }
export function useGetMyCfnStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCfnStackStatusQuery, GetMyCfnStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCfnStackStatusQuery, GetMyCfnStackStatusQueryVariables>(GetMyCfnStackStatusDocument, options);
        }
export type GetMyCfnStackStatusQueryHookResult = ReturnType<typeof useGetMyCfnStackStatusQuery>;
export type GetMyCfnStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyCfnStackStatusLazyQuery>;
export type GetMyCfnStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyCfnStackStatusSuspenseQuery>;
export type GetMyCfnStackStatusQueryResult = Apollo.QueryResult<GetMyCfnStackStatusQuery, GetMyCfnStackStatusQueryVariables>;
export const GetMyCfnStackTemplateDocument = gql`
    query getMyCfnStackTemplate($deploymentId: String!, $stackId: String!) {
  getMyCfnStackTemplate(deploymentId: $deploymentId, stackId: $stackId)
}
    `;

/**
 * __useGetMyCfnStackTemplateQuery__
 *
 * To run a query within a React component, call `useGetMyCfnStackTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCfnStackTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCfnStackTemplateQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyCfnStackTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMyCfnStackTemplateQuery, GetMyCfnStackTemplateQueryVariables> & ({ variables: GetMyCfnStackTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCfnStackTemplateQuery, GetMyCfnStackTemplateQueryVariables>(GetMyCfnStackTemplateDocument, options);
      }
export function useGetMyCfnStackTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCfnStackTemplateQuery, GetMyCfnStackTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCfnStackTemplateQuery, GetMyCfnStackTemplateQueryVariables>(GetMyCfnStackTemplateDocument, options);
        }
export function useGetMyCfnStackTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCfnStackTemplateQuery, GetMyCfnStackTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCfnStackTemplateQuery, GetMyCfnStackTemplateQueryVariables>(GetMyCfnStackTemplateDocument, options);
        }
export type GetMyCfnStackTemplateQueryHookResult = ReturnType<typeof useGetMyCfnStackTemplateQuery>;
export type GetMyCfnStackTemplateLazyQueryHookResult = ReturnType<typeof useGetMyCfnStackTemplateLazyQuery>;
export type GetMyCfnStackTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMyCfnStackTemplateSuspenseQuery>;
export type GetMyCfnStackTemplateQueryResult = Apollo.QueryResult<GetMyCfnStackTemplateQuery, GetMyCfnStackTemplateQueryVariables>;
export const GetMyDbEngineVersionsDocument = gql`
    query getMyDbEngineVersions($deploymentId: String!, $dbType: String!, $family: String!) {
  getMyDbEngineVersions(
    deploymentId: $deploymentId
    dbType: $dbType
    family: $family
  )
}
    `;

/**
 * __useGetMyDbEngineVersionsQuery__
 *
 * To run a query within a React component, call `useGetMyDbEngineVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDbEngineVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDbEngineVersionsQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      dbType: // value for 'dbType'
 *      family: // value for 'family'
 *   },
 * });
 */
export function useGetMyDbEngineVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetMyDbEngineVersionsQuery, GetMyDbEngineVersionsQueryVariables> & ({ variables: GetMyDbEngineVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDbEngineVersionsQuery, GetMyDbEngineVersionsQueryVariables>(GetMyDbEngineVersionsDocument, options);
      }
export function useGetMyDbEngineVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDbEngineVersionsQuery, GetMyDbEngineVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDbEngineVersionsQuery, GetMyDbEngineVersionsQueryVariables>(GetMyDbEngineVersionsDocument, options);
        }
export function useGetMyDbEngineVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDbEngineVersionsQuery, GetMyDbEngineVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDbEngineVersionsQuery, GetMyDbEngineVersionsQueryVariables>(GetMyDbEngineVersionsDocument, options);
        }
export type GetMyDbEngineVersionsQueryHookResult = ReturnType<typeof useGetMyDbEngineVersionsQuery>;
export type GetMyDbEngineVersionsLazyQueryHookResult = ReturnType<typeof useGetMyDbEngineVersionsLazyQuery>;
export type GetMyDbEngineVersionsSuspenseQueryHookResult = ReturnType<typeof useGetMyDbEngineVersionsSuspenseQuery>;
export type GetMyDbEngineVersionsQueryResult = Apollo.QueryResult<GetMyDbEngineVersionsQuery, GetMyDbEngineVersionsQueryVariables>;
export const GetMyDbFamiliesDocument = gql`
    query getMyDbFamilies($deploymentId: String!, $dbType: String!) {
  getMyDbFamilies(deploymentId: $deploymentId, dbType: $dbType)
}
    `;

/**
 * __useGetMyDbFamiliesQuery__
 *
 * To run a query within a React component, call `useGetMyDbFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDbFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDbFamiliesQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      dbType: // value for 'dbType'
 *   },
 * });
 */
export function useGetMyDbFamiliesQuery(baseOptions: Apollo.QueryHookOptions<GetMyDbFamiliesQuery, GetMyDbFamiliesQueryVariables> & ({ variables: GetMyDbFamiliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDbFamiliesQuery, GetMyDbFamiliesQueryVariables>(GetMyDbFamiliesDocument, options);
      }
export function useGetMyDbFamiliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDbFamiliesQuery, GetMyDbFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDbFamiliesQuery, GetMyDbFamiliesQueryVariables>(GetMyDbFamiliesDocument, options);
        }
export function useGetMyDbFamiliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDbFamiliesQuery, GetMyDbFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDbFamiliesQuery, GetMyDbFamiliesQueryVariables>(GetMyDbFamiliesDocument, options);
        }
export type GetMyDbFamiliesQueryHookResult = ReturnType<typeof useGetMyDbFamiliesQuery>;
export type GetMyDbFamiliesLazyQueryHookResult = ReturnType<typeof useGetMyDbFamiliesLazyQuery>;
export type GetMyDbFamiliesSuspenseQueryHookResult = ReturnType<typeof useGetMyDbFamiliesSuspenseQuery>;
export type GetMyDbFamiliesQueryResult = Apollo.QueryResult<GetMyDbFamiliesQuery, GetMyDbFamiliesQueryVariables>;
export const GetMyDbInstanceClassesDocument = gql`
    query getMyDbInstanceClasses($deploymentId: String!, $dbType: String!, $engineVersion: String!) {
  getMyDbInstanceClasses(
    deploymentId: $deploymentId
    dbType: $dbType
    engineVersion: $engineVersion
  )
}
    `;

/**
 * __useGetMyDbInstanceClassesQuery__
 *
 * To run a query within a React component, call `useGetMyDbInstanceClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDbInstanceClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDbInstanceClassesQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      dbType: // value for 'dbType'
 *      engineVersion: // value for 'engineVersion'
 *   },
 * });
 */
export function useGetMyDbInstanceClassesQuery(baseOptions: Apollo.QueryHookOptions<GetMyDbInstanceClassesQuery, GetMyDbInstanceClassesQueryVariables> & ({ variables: GetMyDbInstanceClassesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDbInstanceClassesQuery, GetMyDbInstanceClassesQueryVariables>(GetMyDbInstanceClassesDocument, options);
      }
export function useGetMyDbInstanceClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDbInstanceClassesQuery, GetMyDbInstanceClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDbInstanceClassesQuery, GetMyDbInstanceClassesQueryVariables>(GetMyDbInstanceClassesDocument, options);
        }
export function useGetMyDbInstanceClassesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDbInstanceClassesQuery, GetMyDbInstanceClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDbInstanceClassesQuery, GetMyDbInstanceClassesQueryVariables>(GetMyDbInstanceClassesDocument, options);
        }
export type GetMyDbInstanceClassesQueryHookResult = ReturnType<typeof useGetMyDbInstanceClassesQuery>;
export type GetMyDbInstanceClassesLazyQueryHookResult = ReturnType<typeof useGetMyDbInstanceClassesLazyQuery>;
export type GetMyDbInstanceClassesSuspenseQueryHookResult = ReturnType<typeof useGetMyDbInstanceClassesSuspenseQuery>;
export type GetMyDbInstanceClassesQueryResult = Apollo.QueryResult<GetMyDbInstanceClassesQuery, GetMyDbInstanceClassesQueryVariables>;
export const GetMyDbServiceStackStatusDocument = gql`
    query GetMyDbServiceStackStatus($deploymentId: String!, $databaseId: String!, $stackId: String) {
  getMyDbServiceStackStatus(
    deploymentId: $deploymentId
    databaseId: $databaseId
    stackId: $stackId
  ) {
    id
    status
    parametersJSON
    stackId
  }
}
    `;

/**
 * __useGetMyDbServiceStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyDbServiceStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDbServiceStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDbServiceStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      databaseId: // value for 'databaseId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyDbServiceStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyDbServiceStackStatusQuery, GetMyDbServiceStackStatusQueryVariables> & ({ variables: GetMyDbServiceStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDbServiceStackStatusQuery, GetMyDbServiceStackStatusQueryVariables>(GetMyDbServiceStackStatusDocument, options);
      }
export function useGetMyDbServiceStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDbServiceStackStatusQuery, GetMyDbServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDbServiceStackStatusQuery, GetMyDbServiceStackStatusQueryVariables>(GetMyDbServiceStackStatusDocument, options);
        }
export function useGetMyDbServiceStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDbServiceStackStatusQuery, GetMyDbServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDbServiceStackStatusQuery, GetMyDbServiceStackStatusQueryVariables>(GetMyDbServiceStackStatusDocument, options);
        }
export type GetMyDbServiceStackStatusQueryHookResult = ReturnType<typeof useGetMyDbServiceStackStatusQuery>;
export type GetMyDbServiceStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyDbServiceStackStatusLazyQuery>;
export type GetMyDbServiceStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyDbServiceStackStatusSuspenseQuery>;
export type GetMyDbServiceStackStatusQueryResult = Apollo.QueryResult<GetMyDbServiceStackStatusQuery, GetMyDbServiceStackStatusQueryVariables>;
export const GetMyDbSnapshotIdsDocument = gql`
    query getMyDbSnapshotIds($deploymentId: String!) {
  getMyDbSnapshotIds(deploymentId: $deploymentId)
}
    `;

/**
 * __useGetMyDbSnapshotIdsQuery__
 *
 * To run a query within a React component, call `useGetMyDbSnapshotIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDbSnapshotIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDbSnapshotIdsQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetMyDbSnapshotIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMyDbSnapshotIdsQuery, GetMyDbSnapshotIdsQueryVariables> & ({ variables: GetMyDbSnapshotIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDbSnapshotIdsQuery, GetMyDbSnapshotIdsQueryVariables>(GetMyDbSnapshotIdsDocument, options);
      }
export function useGetMyDbSnapshotIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDbSnapshotIdsQuery, GetMyDbSnapshotIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDbSnapshotIdsQuery, GetMyDbSnapshotIdsQueryVariables>(GetMyDbSnapshotIdsDocument, options);
        }
export function useGetMyDbSnapshotIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDbSnapshotIdsQuery, GetMyDbSnapshotIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDbSnapshotIdsQuery, GetMyDbSnapshotIdsQueryVariables>(GetMyDbSnapshotIdsDocument, options);
        }
export type GetMyDbSnapshotIdsQueryHookResult = ReturnType<typeof useGetMyDbSnapshotIdsQuery>;
export type GetMyDbSnapshotIdsLazyQueryHookResult = ReturnType<typeof useGetMyDbSnapshotIdsLazyQuery>;
export type GetMyDbSnapshotIdsSuspenseQueryHookResult = ReturnType<typeof useGetMyDbSnapshotIdsSuspenseQuery>;
export type GetMyDbSnapshotIdsQueryResult = Apollo.QueryResult<GetMyDbSnapshotIdsQuery, GetMyDbSnapshotIdsQueryVariables>;
export const GetMyEcsServiceStackPublicUrlDocument = gql`
    query getMyEcsServiceStackPublicUrl($deploymentId: String!, $pipelineId: String!) {
  getMyEcsServiceStackPublicUrl(
    deploymentId: $deploymentId
    pipelineId: $pipelineId
  )
}
    `;

/**
 * __useGetMyEcsServiceStackPublicUrlQuery__
 *
 * To run a query within a React component, call `useGetMyEcsServiceStackPublicUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEcsServiceStackPublicUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEcsServiceStackPublicUrlQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useGetMyEcsServiceStackPublicUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyEcsServiceStackPublicUrlQuery, GetMyEcsServiceStackPublicUrlQueryVariables> & ({ variables: GetMyEcsServiceStackPublicUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEcsServiceStackPublicUrlQuery, GetMyEcsServiceStackPublicUrlQueryVariables>(GetMyEcsServiceStackPublicUrlDocument, options);
      }
export function useGetMyEcsServiceStackPublicUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEcsServiceStackPublicUrlQuery, GetMyEcsServiceStackPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEcsServiceStackPublicUrlQuery, GetMyEcsServiceStackPublicUrlQueryVariables>(GetMyEcsServiceStackPublicUrlDocument, options);
        }
export function useGetMyEcsServiceStackPublicUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEcsServiceStackPublicUrlQuery, GetMyEcsServiceStackPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEcsServiceStackPublicUrlQuery, GetMyEcsServiceStackPublicUrlQueryVariables>(GetMyEcsServiceStackPublicUrlDocument, options);
        }
export type GetMyEcsServiceStackPublicUrlQueryHookResult = ReturnType<typeof useGetMyEcsServiceStackPublicUrlQuery>;
export type GetMyEcsServiceStackPublicUrlLazyQueryHookResult = ReturnType<typeof useGetMyEcsServiceStackPublicUrlLazyQuery>;
export type GetMyEcsServiceStackPublicUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyEcsServiceStackPublicUrlSuspenseQuery>;
export type GetMyEcsServiceStackPublicUrlQueryResult = Apollo.QueryResult<GetMyEcsServiceStackPublicUrlQuery, GetMyEcsServiceStackPublicUrlQueryVariables>;
export const GetMyEcsServiceStackStatusDocument = gql`
    query GetMyEcsServiceStackStatus($deploymentId: String!, $pipelineId: String!, $stackId: String) {
  getMyEcsServiceStackStatus(
    deploymentId: $deploymentId
    pipelineId: $pipelineId
    stackId: $stackId
  ) {
    id
    status
    parametersJSON
    stackId
  }
}
    `;

/**
 * __useGetMyEcsServiceStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyEcsServiceStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEcsServiceStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEcsServiceStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyEcsServiceStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyEcsServiceStackStatusQuery, GetMyEcsServiceStackStatusQueryVariables> & ({ variables: GetMyEcsServiceStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEcsServiceStackStatusQuery, GetMyEcsServiceStackStatusQueryVariables>(GetMyEcsServiceStackStatusDocument, options);
      }
export function useGetMyEcsServiceStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEcsServiceStackStatusQuery, GetMyEcsServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEcsServiceStackStatusQuery, GetMyEcsServiceStackStatusQueryVariables>(GetMyEcsServiceStackStatusDocument, options);
        }
export function useGetMyEcsServiceStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEcsServiceStackStatusQuery, GetMyEcsServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEcsServiceStackStatusQuery, GetMyEcsServiceStackStatusQueryVariables>(GetMyEcsServiceStackStatusDocument, options);
        }
export type GetMyEcsServiceStackStatusQueryHookResult = ReturnType<typeof useGetMyEcsServiceStackStatusQuery>;
export type GetMyEcsServiceStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyEcsServiceStackStatusLazyQuery>;
export type GetMyEcsServiceStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyEcsServiceStackStatusSuspenseQuery>;
export type GetMyEcsServiceStackStatusQueryResult = Apollo.QueryResult<GetMyEcsServiceStackStatusQuery, GetMyEcsServiceStackStatusQueryVariables>;
export const GetMyEcsWsServiceStackPublicUrlDocument = gql`
    query getMyEcsWsServiceStackPublicUrl($deploymentId: String!, $pipelineId: String!) {
  getMyEcsWsServiceStackPublicUrl(
    deploymentId: $deploymentId
    pipelineId: $pipelineId
  )
}
    `;

/**
 * __useGetMyEcsWsServiceStackPublicUrlQuery__
 *
 * To run a query within a React component, call `useGetMyEcsWsServiceStackPublicUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEcsWsServiceStackPublicUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEcsWsServiceStackPublicUrlQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useGetMyEcsWsServiceStackPublicUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyEcsWsServiceStackPublicUrlQuery, GetMyEcsWsServiceStackPublicUrlQueryVariables> & ({ variables: GetMyEcsWsServiceStackPublicUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEcsWsServiceStackPublicUrlQuery, GetMyEcsWsServiceStackPublicUrlQueryVariables>(GetMyEcsWsServiceStackPublicUrlDocument, options);
      }
export function useGetMyEcsWsServiceStackPublicUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEcsWsServiceStackPublicUrlQuery, GetMyEcsWsServiceStackPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEcsWsServiceStackPublicUrlQuery, GetMyEcsWsServiceStackPublicUrlQueryVariables>(GetMyEcsWsServiceStackPublicUrlDocument, options);
        }
export function useGetMyEcsWsServiceStackPublicUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEcsWsServiceStackPublicUrlQuery, GetMyEcsWsServiceStackPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEcsWsServiceStackPublicUrlQuery, GetMyEcsWsServiceStackPublicUrlQueryVariables>(GetMyEcsWsServiceStackPublicUrlDocument, options);
        }
export type GetMyEcsWsServiceStackPublicUrlQueryHookResult = ReturnType<typeof useGetMyEcsWsServiceStackPublicUrlQuery>;
export type GetMyEcsWsServiceStackPublicUrlLazyQueryHookResult = ReturnType<typeof useGetMyEcsWsServiceStackPublicUrlLazyQuery>;
export type GetMyEcsWsServiceStackPublicUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyEcsWsServiceStackPublicUrlSuspenseQuery>;
export type GetMyEcsWsServiceStackPublicUrlQueryResult = Apollo.QueryResult<GetMyEcsWsServiceStackPublicUrlQuery, GetMyEcsWsServiceStackPublicUrlQueryVariables>;
export const GetMyEcsWsServiceStackStatusDocument = gql`
    query GetMyEcsWsServiceStackStatus($deploymentId: String!, $pipelineId: String!, $stackId: String) {
  getMyEcsWsServiceStackStatus(
    deploymentId: $deploymentId
    pipelineId: $pipelineId
    stackId: $stackId
  ) {
    id
    status
    parametersJSON
    stackId
  }
}
    `;

/**
 * __useGetMyEcsWsServiceStackStatusQuery__
 *
 * To run a query within a React component, call `useGetMyEcsWsServiceStackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEcsWsServiceStackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEcsWsServiceStackStatusQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *      stackId: // value for 'stackId'
 *   },
 * });
 */
export function useGetMyEcsWsServiceStackStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMyEcsWsServiceStackStatusQuery, GetMyEcsWsServiceStackStatusQueryVariables> & ({ variables: GetMyEcsWsServiceStackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEcsWsServiceStackStatusQuery, GetMyEcsWsServiceStackStatusQueryVariables>(GetMyEcsWsServiceStackStatusDocument, options);
      }
export function useGetMyEcsWsServiceStackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEcsWsServiceStackStatusQuery, GetMyEcsWsServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEcsWsServiceStackStatusQuery, GetMyEcsWsServiceStackStatusQueryVariables>(GetMyEcsWsServiceStackStatusDocument, options);
        }
export function useGetMyEcsWsServiceStackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEcsWsServiceStackStatusQuery, GetMyEcsWsServiceStackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEcsWsServiceStackStatusQuery, GetMyEcsWsServiceStackStatusQueryVariables>(GetMyEcsWsServiceStackStatusDocument, options);
        }
export type GetMyEcsWsServiceStackStatusQueryHookResult = ReturnType<typeof useGetMyEcsWsServiceStackStatusQuery>;
export type GetMyEcsWsServiceStackStatusLazyQueryHookResult = ReturnType<typeof useGetMyEcsWsServiceStackStatusLazyQuery>;
export type GetMyEcsWsServiceStackStatusSuspenseQueryHookResult = ReturnType<typeof useGetMyEcsWsServiceStackStatusSuspenseQuery>;
export type GetMyEcsWsServiceStackStatusQueryResult = Apollo.QueryResult<GetMyEcsWsServiceStackStatusQuery, GetMyEcsWsServiceStackStatusQueryVariables>;
export const GetMyServiceStacksDocument = gql`
    query GetMyServiceStacks {
  getMyServiceStacks {
    id
    name
    type
  }
}
    `;

/**
 * __useGetMyServiceStacksQuery__
 *
 * To run a query within a React component, call `useGetMyServiceStacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyServiceStacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyServiceStacksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyServiceStacksQuery(baseOptions?: Apollo.QueryHookOptions<GetMyServiceStacksQuery, GetMyServiceStacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyServiceStacksQuery, GetMyServiceStacksQueryVariables>(GetMyServiceStacksDocument, options);
      }
export function useGetMyServiceStacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyServiceStacksQuery, GetMyServiceStacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyServiceStacksQuery, GetMyServiceStacksQueryVariables>(GetMyServiceStacksDocument, options);
        }
export function useGetMyServiceStacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyServiceStacksQuery, GetMyServiceStacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyServiceStacksQuery, GetMyServiceStacksQueryVariables>(GetMyServiceStacksDocument, options);
        }
export type GetMyServiceStacksQueryHookResult = ReturnType<typeof useGetMyServiceStacksQuery>;
export type GetMyServiceStacksLazyQueryHookResult = ReturnType<typeof useGetMyServiceStacksLazyQuery>;
export type GetMyServiceStacksSuspenseQueryHookResult = ReturnType<typeof useGetMyServiceStacksSuspenseQuery>;
export type GetMyServiceStacksQueryResult = Apollo.QueryResult<GetMyServiceStacksQuery, GetMyServiceStacksQueryVariables>;
export const RemoveMyCdnStackDocument = gql`
    mutation RemoveMyCdnStack($stackId: String, $deploymentId: String!, $pipelineId: String!) {
  removeMyCdnStack(
    stackId: $stackId
    deploymentId: $deploymentId
    pipelineId: $pipelineId
  )
}
    `;
export type RemoveMyCdnStackMutationFn = Apollo.MutationFunction<RemoveMyCdnStackMutation, RemoveMyCdnStackMutationVariables>;

/**
 * __useRemoveMyCdnStackMutation__
 *
 * To run a mutation, you first call `useRemoveMyCdnStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyCdnStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyCdnStackMutation, { data, loading, error }] = useRemoveMyCdnStackMutation({
 *   variables: {
 *      stackId: // value for 'stackId'
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useRemoveMyCdnStackMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyCdnStackMutation, RemoveMyCdnStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyCdnStackMutation, RemoveMyCdnStackMutationVariables>(RemoveMyCdnStackDocument, options);
      }
export type RemoveMyCdnStackMutationHookResult = ReturnType<typeof useRemoveMyCdnStackMutation>;
export type RemoveMyCdnStackMutationResult = Apollo.MutationResult<RemoveMyCdnStackMutation>;
export type RemoveMyCdnStackMutationOptions = Apollo.BaseMutationOptions<RemoveMyCdnStackMutation, RemoveMyCdnStackMutationVariables>;
export const RemoveMyCfnStackDocument = gql`
    mutation RemoveMyCfnStack($stackId: String, $deploymentId: String!, $pipelineId: String!) {
  removeMyCfnStack(
    stackId: $stackId
    deploymentId: $deploymentId
    pipelineId: $pipelineId
  )
}
    `;
export type RemoveMyCfnStackMutationFn = Apollo.MutationFunction<RemoveMyCfnStackMutation, RemoveMyCfnStackMutationVariables>;

/**
 * __useRemoveMyCfnStackMutation__
 *
 * To run a mutation, you first call `useRemoveMyCfnStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyCfnStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyCfnStackMutation, { data, loading, error }] = useRemoveMyCfnStackMutation({
 *   variables: {
 *      stackId: // value for 'stackId'
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useRemoveMyCfnStackMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyCfnStackMutation, RemoveMyCfnStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyCfnStackMutation, RemoveMyCfnStackMutationVariables>(RemoveMyCfnStackDocument, options);
      }
export type RemoveMyCfnStackMutationHookResult = ReturnType<typeof useRemoveMyCfnStackMutation>;
export type RemoveMyCfnStackMutationResult = Apollo.MutationResult<RemoveMyCfnStackMutation>;
export type RemoveMyCfnStackMutationOptions = Apollo.BaseMutationOptions<RemoveMyCfnStackMutation, RemoveMyCfnStackMutationVariables>;
export const RemoveMyDbStackDocument = gql`
    mutation RemoveMyDbStack($stackId: String, $deploymentId: String!, $databaseId: String!) {
  removeMyDbStack(
    stackId: $stackId
    deploymentId: $deploymentId
    databaseId: $databaseId
  )
}
    `;
export type RemoveMyDbStackMutationFn = Apollo.MutationFunction<RemoveMyDbStackMutation, RemoveMyDbStackMutationVariables>;

/**
 * __useRemoveMyDbStackMutation__
 *
 * To run a mutation, you first call `useRemoveMyDbStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyDbStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyDbStackMutation, { data, loading, error }] = useRemoveMyDbStackMutation({
 *   variables: {
 *      stackId: // value for 'stackId'
 *      deploymentId: // value for 'deploymentId'
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useRemoveMyDbStackMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyDbStackMutation, RemoveMyDbStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyDbStackMutation, RemoveMyDbStackMutationVariables>(RemoveMyDbStackDocument, options);
      }
export type RemoveMyDbStackMutationHookResult = ReturnType<typeof useRemoveMyDbStackMutation>;
export type RemoveMyDbStackMutationResult = Apollo.MutationResult<RemoveMyDbStackMutation>;
export type RemoveMyDbStackMutationOptions = Apollo.BaseMutationOptions<RemoveMyDbStackMutation, RemoveMyDbStackMutationVariables>;
export const RemoveMyEcsFargateStackDocument = gql`
    mutation RemoveMyEcsFargateStack($stackId: String, $deploymentId: String!, $pipelineId: String!) {
  removeMyEcsFargateStack(
    stackId: $stackId
    deploymentId: $deploymentId
    pipelineId: $pipelineId
  )
}
    `;
export type RemoveMyEcsFargateStackMutationFn = Apollo.MutationFunction<RemoveMyEcsFargateStackMutation, RemoveMyEcsFargateStackMutationVariables>;

/**
 * __useRemoveMyEcsFargateStackMutation__
 *
 * To run a mutation, you first call `useRemoveMyEcsFargateStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyEcsFargateStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyEcsFargateStackMutation, { data, loading, error }] = useRemoveMyEcsFargateStackMutation({
 *   variables: {
 *      stackId: // value for 'stackId'
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useRemoveMyEcsFargateStackMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyEcsFargateStackMutation, RemoveMyEcsFargateStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyEcsFargateStackMutation, RemoveMyEcsFargateStackMutationVariables>(RemoveMyEcsFargateStackDocument, options);
      }
export type RemoveMyEcsFargateStackMutationHookResult = ReturnType<typeof useRemoveMyEcsFargateStackMutation>;
export type RemoveMyEcsFargateStackMutationResult = Apollo.MutationResult<RemoveMyEcsFargateStackMutation>;
export type RemoveMyEcsFargateStackMutationOptions = Apollo.BaseMutationOptions<RemoveMyEcsFargateStackMutation, RemoveMyEcsFargateStackMutationVariables>;
export const RemoveMyEcsWsFargateStackDocument = gql`
    mutation RemoveMyEcsWsFargateStack($stackId: String, $deploymentId: String!, $pipelineId: String!) {
  removeMyEcsWsFargateStack(
    stackId: $stackId
    deploymentId: $deploymentId
    pipelineId: $pipelineId
  )
}
    `;
export type RemoveMyEcsWsFargateStackMutationFn = Apollo.MutationFunction<RemoveMyEcsWsFargateStackMutation, RemoveMyEcsWsFargateStackMutationVariables>;

/**
 * __useRemoveMyEcsWsFargateStackMutation__
 *
 * To run a mutation, you first call `useRemoveMyEcsWsFargateStackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyEcsWsFargateStackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyEcsWsFargateStackMutation, { data, loading, error }] = useRemoveMyEcsWsFargateStackMutation({
 *   variables: {
 *      stackId: // value for 'stackId'
 *      deploymentId: // value for 'deploymentId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useRemoveMyEcsWsFargateStackMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyEcsWsFargateStackMutation, RemoveMyEcsWsFargateStackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyEcsWsFargateStackMutation, RemoveMyEcsWsFargateStackMutationVariables>(RemoveMyEcsWsFargateStackDocument, options);
      }
export type RemoveMyEcsWsFargateStackMutationHookResult = ReturnType<typeof useRemoveMyEcsWsFargateStackMutation>;
export type RemoveMyEcsWsFargateStackMutationResult = Apollo.MutationResult<RemoveMyEcsWsFargateStackMutation>;
export type RemoveMyEcsWsFargateStackMutationOptions = Apollo.BaseMutationOptions<RemoveMyEcsWsFargateStackMutation, RemoveMyEcsWsFargateStackMutationVariables>;
export const GetMyTeamMembersDocument = gql`
    query GetMyTeamMembers {
  getMyTeamMembers {
    id
    name
    email
    status
  }
}
    `;

/**
 * __useGetMyTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetMyTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
      }
export function useGetMyTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export function useGetMyTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export type GetMyTeamMembersQueryHookResult = ReturnType<typeof useGetMyTeamMembersQuery>;
export type GetMyTeamMembersLazyQueryHookResult = ReturnType<typeof useGetMyTeamMembersLazyQuery>;
export type GetMyTeamMembersSuspenseQueryHookResult = ReturnType<typeof useGetMyTeamMembersSuspenseQuery>;
export type GetMyTeamMembersQueryResult = Apollo.QueryResult<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>;
export const InviteMyTeamMemberDocument = gql`
    mutation InviteMyTeamMember($email: String!) {
  inviteMyTeamMember(email: $email) {
    id
    name
    email
    status
  }
}
    `;
export type InviteMyTeamMemberMutationFn = Apollo.MutationFunction<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>;

/**
 * __useInviteMyTeamMemberMutation__
 *
 * To run a mutation, you first call `useInviteMyTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMyTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMyTeamMemberMutation, { data, loading, error }] = useInviteMyTeamMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteMyTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>(InviteMyTeamMemberDocument, options);
      }
export type InviteMyTeamMemberMutationHookResult = ReturnType<typeof useInviteMyTeamMemberMutation>;
export type InviteMyTeamMemberMutationResult = Apollo.MutationResult<InviteMyTeamMemberMutation>;
export type InviteMyTeamMemberMutationOptions = Apollo.BaseMutationOptions<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>;
export const SetMyOrganizationDocument = gql`
    mutation SetMyOrganization($organizationName: String!) {
  setMyOrganization(organizationName: $organizationName) {
    id
    name
    features {
      singleDeployment
    }
    onboardingComplete
  }
}
    `;
export type SetMyOrganizationMutationFn = Apollo.MutationFunction<SetMyOrganizationMutation, SetMyOrganizationMutationVariables>;

/**
 * __useSetMyOrganizationMutation__
 *
 * To run a mutation, you first call `useSetMyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyOrganizationMutation, { data, loading, error }] = useSetMyOrganizationMutation({
 *   variables: {
 *      organizationName: // value for 'organizationName'
 *   },
 * });
 */
export function useSetMyOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SetMyOrganizationMutation, SetMyOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyOrganizationMutation, SetMyOrganizationMutationVariables>(SetMyOrganizationDocument, options);
      }
export type SetMyOrganizationMutationHookResult = ReturnType<typeof useSetMyOrganizationMutation>;
export type SetMyOrganizationMutationResult = Apollo.MutationResult<SetMyOrganizationMutation>;
export type SetMyOrganizationMutationOptions = Apollo.BaseMutationOptions<SetMyOrganizationMutation, SetMyOrganizationMutationVariables>;
export const WhoAmIDocument = gql`
    query WhoAmI {
  whoAmI {
    id
    name
    email
    phoneNumber
    picture
    role
    organizationId
  }
}
    `;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
      }
export function useWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export function useWhoAmISuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmISuspenseQueryHookResult = ReturnType<typeof useWhoAmISuspenseQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<WhoAmIQuery, WhoAmIQueryVariables>;
export const namedOperations = {
  Query: {
    GetMyCertificateCnameRecordStatus: 'GetMyCertificateCnameRecordStatus',
    GetMyDeployments: 'GetMyDeployments',
    GetMyDomainNameCertificate: 'GetMyDomainNameCertificate',
    getMyEnvFeaturesStackStatus: 'getMyEnvFeaturesStackStatus',
    GetMyGitConnections: 'GetMyGitConnections',
    getMyHostedZoneChangeStatus: 'getMyHostedZoneChangeStatus',
    getMyHostedZones: 'getMyHostedZones',
    getMyHttpApiUrl: 'getMyHttpApiUrl',
    getMyRestApiUrl: 'getMyRestApiUrl',
    GetMyWaffleCfnTemplate: 'GetMyWaffleCfnTemplate',
    getMyAlertsStackStatus: 'getMyAlertsStackStatus',
    getMyAuthenticationStackStatus: 'getMyAuthenticationStackStatus',
    getMyDeploymentsStackStatus: 'getMyDeploymentsStackStatus',
    getMyHttpApiV2StackStatus: 'getMyHttpApiV2StackStatus',
    getMyRestApiV1StackStatus: 'getMyRestApiV1StackStatus',
    getMyVpcStackStatus: 'getMyVpcStackStatus',
    TestMyWaffleRole: 'TestMyWaffleRole',
    HelloWorld: 'HelloWorld',
    GetAllOrganizations: 'GetAllOrganizations',
    GetMyOrganization: 'GetMyOrganization',
    GetOrganization: 'GetOrganization',
    getMyCdnServiceStackPublicUrl: 'getMyCdnServiceStackPublicUrl',
    GetMyCdnServiceStackStatus: 'GetMyCdnServiceStackStatus',
    GetMyCfnServiceStackStatus: 'GetMyCfnServiceStackStatus',
    getMyCfnStackIds: 'getMyCfnStackIds',
    getMyCfnStackLatestEvents: 'getMyCfnStackLatestEvents',
    getMyCfnStackParameters: 'getMyCfnStackParameters',
    getMyCfnStackStatus: 'getMyCfnStackStatus',
    getMyCfnStackTemplate: 'getMyCfnStackTemplate',
    getMyDbEngineVersions: 'getMyDbEngineVersions',
    getMyDbFamilies: 'getMyDbFamilies',
    getMyDbInstanceClasses: 'getMyDbInstanceClasses',
    GetMyDbServiceStackStatus: 'GetMyDbServiceStackStatus',
    getMyDbSnapshotIds: 'getMyDbSnapshotIds',
    getMyEcsServiceStackPublicUrl: 'getMyEcsServiceStackPublicUrl',
    GetMyEcsServiceStackStatus: 'GetMyEcsServiceStackStatus',
    getMyEcsWsServiceStackPublicUrl: 'getMyEcsWsServiceStackPublicUrl',
    GetMyEcsWsServiceStackStatus: 'GetMyEcsWsServiceStackStatus',
    GetMyServiceStacks: 'GetMyServiceStacks',
    GetMyTeamMembers: 'GetMyTeamMembers',
    WhoAmI: 'WhoAmI'
  },
  Mutation: {
    AssignMyDeploymentAccountAndRegion: 'AssignMyDeploymentAccountAndRegion',
    CreateMyDeployment: 'CreateMyDeployment',
    CreateMyGitConnection: 'CreateMyGitConnection',
    CreateMyHostedZoneWithCert: 'CreateMyHostedZoneWithCert',
    DeployMyApiGatewayStage: 'DeployMyApiGatewayStage',
    DeployMyEnvFeaturesStack: 'DeployMyEnvFeaturesStack',
    EditMyDeployment: 'EditMyDeployment',
    TempTestMyWaffleRole: 'TempTestMyWaffleRole',
    AddOrganization: 'AddOrganization',
    EditOrganization: 'EditOrganization',
    SetMyOnboardingComplete: 'SetMyOnboardingComplete',
    AddMyServiceStack: 'AddMyServiceStack',
    deployMyAnyCfnStack: 'deployMyAnyCfnStack',
    DeployMyCdnStack: 'DeployMyCdnStack',
    DeployMyCfnStack: 'DeployMyCfnStack',
    DeployMyDbStack: 'DeployMyDbStack',
    DeployMyEcsFargateStack: 'DeployMyEcsFargateStack',
    DeployMyEcsWsFargateStack: 'DeployMyEcsWsFargateStack',
    EditMyServiceStack: 'EditMyServiceStack',
    RemoveMyCdnStack: 'RemoveMyCdnStack',
    RemoveMyCfnStack: 'RemoveMyCfnStack',
    RemoveMyDbStack: 'RemoveMyDbStack',
    RemoveMyEcsFargateStack: 'RemoveMyEcsFargateStack',
    RemoveMyEcsWsFargateStack: 'RemoveMyEcsWsFargateStack',
    InviteMyTeamMember: 'InviteMyTeamMember',
    SetMyOrganization: 'SetMyOrganization'
  }
}